import webDevelopmentHero from '../assets/images/main-slider/web-development-hero.png';
import mobileAppDevelopmentHero from '../assets/images/main-slider/mobile-app-development-hero.png';
import whatsappCrmHero from '../assets/images/main-slider/whatsapp-crm-hero.png';
import softwareErpDevelopmentHero from '../assets/images/main-slider/software-erp-development-hero.png';
import aiAgentDevelopmentHero from '../assets/images/main-slider/ai-agent-development-hero.png';
import digitalMarketingHero from '../assets/images/main-slider/digital-marketing-hero.png';
import omanWebDevelopmentHero from '../assets/images/main-slider/oman-web-development-hero.png';
import serviceOgImageOne from '../assets/images/main-slider/web-development-hero.png';
import serviceOgImageTwo from '../assets/images/main-slider/software-erp-development-hero.png';
import serviceOgImageThree from '../assets/images/main-slider/mobile-app-development-hero.png';
import serviceOgImageFour from '../assets/images/resource/feature-1.jpg';
import serviceOgImageFive from '../assets/images/main-slider/digital-marketing-hero.png';
import serviceOgImageSix from '../assets/images/main-slider/ai-agent-development-hero.png';
import serviceOgImageSeven from '../assets/images/main-slider/training-internship-hero.png';
import sectionVisualImage from '../assets/images/main-slider/web-development-hero.png';

const commonDelivery = (workflow, usage, maintenance) => [
  {
    number: '01',
    title: workflow,
    text: 'We define the real workflow, business goal, and delivery scope before development starts.',
  },
  {
    number: '02',
    title: usage,
    text: 'The service is designed around practical day-to-day usage instead of generic feature lists.',
  },
  {
    number: '03',
    title: maintenance,
    text: 'The final solution stays clean, scalable, and easier to improve as your business grows.',
  },
];

const webGeneralReviews = [
  {
    name: 'Jay Patel',
    position: 'Business Owner, India',
    rating: 5,
    message:
      'SwiftMaze built a website that looks professional and actually helps us get enquiries. The structure and CTA flow were planned properly.',
  },
  {
    name: 'Olivia Brooks',
    position: 'Consultant, Canada',
    rating: 5,
    message:
      'Clear communication, fast delivery, and a practical website setup. The final product felt clean, modern, and business-ready.',
  },
  {
    name: 'Hiren Shah',
    position: 'Service Provider, India',
    rating: 5,
    message:
      'They kept the website simple for users and focused on speed, mobile view, and conversions. That made a real difference for us.',
  },
  {
    name: 'Daniel Moore',
    position: 'Operations Lead, UAE',
    rating: 5,
    message:
      'The website was not only visually strong but also structured for growth. Good execution and reliable support.',
  },
];

const webModasaReviews = [
  {
    name: 'Kishan Soni',
    position: 'Retail Owner, Modasa',
    rating: 5,
    message:
      'SwiftMaze helped us present our business properly online. The website feels clearer for local customers and enquiries became easier to manage.',
  },
  {
    name: 'Dhruvi Patel',
    position: 'Coaching Coordinator, Modasa',
    rating: 5,
    message:
      'They understood the local audience and suggested the right page structure. The website now looks more trusted and easy to use.',
  },
  {
    name: 'Parth Mehta',
    position: 'Service Provider, Himatnagar',
    rating: 5,
    message:
      'The team kept the project practical and gave us a professional site that works well for nearby city traffic too.',
  },
  {
    name: 'Niyati Shah',
    position: 'Business Partner, Aravalli',
    rating: 5,
    message:
      'Good local business understanding, responsive support, and a website that explains our services much better than before.',
  },
];

const appGeneralReviews = [
  {
    name: 'Ritesh Prajapati',
    position: 'Founder, India',
    rating: 5,
    message:
      'SwiftMaze planned the app flow around our actual users, not just screens. The result was smoother onboarding and better retention.',
  },
  {
    name: 'Amelia Hayes',
    position: 'Product Manager, Australia',
    rating: 5,
    message:
      'We needed a practical mobile app, not complexity. The team delivered clean UI and stable features with strong communication.',
  },
  {
    name: 'Nisarg Desai',
    position: 'Director, India',
    rating: 5,
    message:
      'The app structure, admin integration, and business logic were handled professionally. It felt ready for real users from day one.',
  },
  {
    name: 'Sophia Miller',
    position: 'Operations Specialist, Singapore',
    rating: 5,
    message:
      'A good development experience overall. The app was aligned with our workflow and the delivery stayed clear and organised.',
  },
];

const appModasaReviews = [
  {
    name: 'Jaimin Shah',
    position: 'Business Owner, Modasa',
    rating: 5,
    message:
      'SwiftMaze helped us turn our app idea into a practical plan. The team kept the flow simple and relevant for our actual users.',
  },
  {
    name: 'Komal Joshi',
    position: 'Operations Coordinator, Modasa',
    rating: 5,
    message:
      'They understood our daily process first and then suggested the mobile app structure. That made the whole project more realistic.',
  },
  {
    name: 'Yug Trivedi',
    position: 'Startup Founder, Himmatnagar',
    rating: 5,
    message:
      'The app planning was clear, business-focused, and easier to understand than what we had discussed with others.',
  },
  {
    name: 'Riya Desai',
    position: 'Brand Manager, Aravalli',
    rating: 5,
    message:
      'Good support, clean communication, and a practical product mindset. The app felt designed for real users, not just presentation.',
  },
];

const crmReviews = [
  {
    name: 'Ketan Trivedi',
    position: 'Sales Head, India',
    rating: 5,
    message:
      'Our lead handling became much more organised after the CRM setup. Follow-up visibility improved immediately.',
  },
  {
    name: 'Grace Wilson',
    position: 'Client Success Manager, United Kingdom',
    rating: 5,
    message:
      'SwiftMaze built a CRM structure that matched our exact sales stages and daily team usage. That made adoption easy.',
  },
  {
    name: 'Ravi Solanki',
    position: 'Business Owner, India',
    rating: 5,
    message:
      'The CRM is simple, clear, and practical. Our staff could start using it without confusion.',
  },
  {
    name: 'Ethan Cooper',
    position: 'Operations Lead, New Zealand',
    rating: 5,
    message:
      'Good understanding of pipeline management and internal workflows. The solution felt stable and well planned.',
  },
];

const erpReviews = [
  {
    name: 'Bhavesh Patel',
    position: 'Factory Owner, India',
    rating: 5,
    message:
      'Our daily operations were scattered before. The ERP approach from SwiftMaze gave us one clearer working system.',
  },
  {
    name: 'Hannah Scott',
    position: 'Process Manager, Germany',
    rating: 5,
    message:
      'The ERP planning was business-first and practical. The team focused on usability, modules, and long-term scaling.',
  },
  {
    name: 'Mitesh Gandhi',
    position: 'Retail Operator, India',
    rating: 5,
    message:
      'Stock, billing, and reporting became easier to manage. The system was designed around our actual process.',
  },
  {
    name: 'Noah Evans',
    position: 'Operations Director, South Africa',
    rating: 5,
    message:
      'A solid ERP implementation mindset. They did not overbuild the system and kept the workflow understandable.',
  },
];

const softwareGeneralReviews = [
  {
    name: 'Pratik Shah',
    position: 'Director, India',
    rating: 5,
    message:
      'SwiftMaze understood our business process properly before building the software. That saved time and rework later.',
  },
  {
    name: 'Chloe Bennett',
    position: 'Operations Consultant, United States',
    rating: 5,
    message:
      'The software planning felt mature and business-focused. They balanced technical quality with practical delivery.',
  },
  {
    name: 'Hardik Mehta',
    position: 'Operations Head, India',
    rating: 5,
    message:
      'We needed a system that actually supported daily work. The final software was clear, stable, and useful.',
  },
  {
    name: 'James Foster',
    position: 'Technology Manager, Singapore',
    rating: 5,
    message:
      'Good architecture thinking, clean communication, and professional implementation. The project stayed grounded in real workflow needs.',
  },
];

const softwareModasaReviews = [
  {
    name: 'Milan Patel',
    position: 'Factory Manager, Modasa',
    rating: 5,
    message:
      'SwiftMaze understood our reporting and workflow issues properly. The software plan felt practical for our local operations team.',
  },
  {
    name: 'Aesha Gandhi',
    position: 'Business Owner, Modasa',
    rating: 5,
    message:
      'We wanted a cleaner internal system instead of spreadsheets everywhere. Their approach was simple, clear, and useful for our business.',
  },
  {
    name: 'Devang Shah',
    position: 'Operations Lead, Aravalli',
    rating: 5,
    message:
      'The team focused on actual business use, not technical jargon. That made software planning much easier for us.',
  },
  {
    name: 'Harshita Mehta',
    position: 'Accounts Coordinator, Himatnagar',
    rating: 5,
    message:
      'Their software consultation was practical and process-focused. We could clearly see how the system would improve daily work.',
  },
];

export const webDevelopmentConfig = {
  seo: {
    title: 'Web Development Company in India | Websites Built for SEO',
    description:
      'SwiftMaze Tech is a web development company in India building responsive, fast business websites, ecommerce stores, landing pages, and custom web applications with a strong SEO foundation.',
    canonical: 'https://www.swiftmazetech.com/services/web-development/',
    ogImage: serviceOgImageOne,
    schemaName: 'Web Development Company in India',
    schemaType: 'Web Development Service in India',
  },
  servicePath: '/services/web-development',
  hero: {
    image: webDevelopmentHero,
    kicker: 'Web Development Company In India',
    title: 'Web Development In India Built For Visibility, Trust, And Growth',
    lead:
      'We build responsive business websites, ecommerce experiences, landing pages, and custom web solutions for companies across India that need stronger visibility and more qualified enquiries.',
    buttonLabel: 'Get Free Consultation',
    buttonSubject: 'Free Web Development Consultation India',
    chips: ['Built for Business', 'SEO Ready', 'Fast Loading', 'Designed for Leads'],
  },
  trustStrip: {
    items: [
      { value: 'Responsive', label: 'Mobile Responsive Websites' },
      { value: 'SEO Setup', label: 'Clear Search Structure' },
      { value: 'Scalable', label: 'Built For Business Growth' },
      { value: 'Nationwide', label: 'Remote Project Delivery' },
    ],
  },
  capability: {
    kicker: 'What We Build',
    title: 'Website Solutions For Businesses Across India',
    text:
      'A business website should not only look good. It should explain your service clearly, load fast, work on mobile, and guide users toward enquiry or action.',
    items: [
      { icon: 'fa-globe', title: 'Business Websites', text: 'Professional websites for Indian service companies, manufacturers, brands, startups, and growing businesses.' },
      { icon: 'fa-bullseye', title: 'Landing Pages', text: 'Pages designed for ads, campaigns, offers, and local lead generation.' },
      { icon: 'fa-code', title: 'Custom Web Apps', text: 'Admin panels, dashboards, and browser workflows built around your process.' },
      { icon: 'fa-line-chart', title: 'Performance And SEO', text: 'Clean structure, faster loading, and a stronger foundation for organic growth.' },
    ],
  },
  featureBreakdown: {
    id: 'web-development-services-india',
    kicker: 'Complete Web Development Services',
    title: 'Web Development Services For Indian Businesses From Idea To Launch',
    text:
      'SwiftMaze Tech combines strategy, UX, development, integrations, performance, and ongoing support so businesses can work with one accountable web development team throughout the project lifecycle.',
    items: [
      { icon: 'fa-building-o', title: 'Corporate Website Development', text: 'Professional company websites with service pages, industry information, leadership profiles, case studies, enquiry paths, and content that builds credibility with Indian and international buyers.' },
      { icon: 'fa-shopping-cart', title: 'Ecommerce Development', text: 'Shopify, WooCommerce, and custom ecommerce experiences with clear product discovery, mobile usability, payment integration, order journeys, and storefronts designed for conversion.' },
      { icon: 'fa-wordpress', title: 'WordPress Development', text: 'Flexible WordPress websites with custom page structures, manageable content, responsive layouts, essential integrations, and a clean foundation for future marketing and SEO work.' },
      { icon: 'fa-code', title: 'React And Custom Development', text: 'Modern React interfaces, custom frontend development, dashboards, portals, and web applications for businesses that need more than a standard informational website.' },
      { icon: 'fa-refresh', title: 'Website Redesign And Migration', text: 'Redesign outdated websites, improve confusing navigation, migrate content carefully, modernise the visual experience, and preserve important business and search value during transition.' },
      { icon: 'fa-plug', title: 'API And Business Integrations', text: 'Connect websites with CRM, payment gateways, forms, analytics, email, WhatsApp, automation tools, and internal systems to reduce disconnected manual work.' },
      { icon: 'fa-tachometer', title: 'Performance Optimisation', text: 'Improve image delivery, code loading, layout stability, mobile experience, and technical structure so visitors can reach important information and actions faster.' },
      { icon: 'fa-search', title: 'Technical SEO Foundation', text: 'Implement crawlable navigation, semantic headings, metadata, canonical setup, structured content, sitemap support, and page architecture that gives ongoing SEO work a stronger base.' },
    ],
  },
  cta: {
    id: 'web-development-free-consultation',
    kicker: 'Free Website Consultation',
    title: 'Get A Free Consultation For Your Website Project',
    text:
      'Share your business, target market, and growth goal. Our team will suggest the right website type, page structure, technology direction, and next steps without obligation.',
    buttonLabel: 'Claim Free Consultation',
    buttonSubject: 'Free Web Development Consultation India',
  },
  ctaPlacement: 'afterAudience',
  useCases: {
    id: 'web-development-india-solutions',
    kicker: 'Solutions Across India',
    title: 'Web Development For Different Business Models And Growth Stages',
    text: 'From a first professional website to a scalable custom platform, we plan the solution around your market, users, and operational needs.',
    items: [
      { icon: 'fa-building-o', title: 'Corporate And Manufacturing Websites', text: 'Structured company profiles, product catalogues, enquiry journeys, and pages that build credibility for B2B businesses.' },
      { icon: 'fa-shopping-cart', title: 'Ecommerce And D2C Stores', text: 'Product discovery, secure checkout integration, smooth mobile shopping, and store experiences designed for conversion.' },
      { icon: 'fa-map-marker', title: 'Local And Multiple Location Businesses', text: 'Service pages for specific locations and enquiry flows that support visibility across cities, districts, and service areas.' },
      { icon: 'fa-cogs', title: 'Custom Portals And Web Applications', text: 'Dashboards, customer portals, admin systems, and browser workflows connected to real business processes.' },
    ],
  },
  workflow: {
    id: 'web-development-process-india',
    kicker: 'Our Process',
    title: 'A Clear Web Development Process From Strategy To Launch',
    text: 'Every phase is planned to reduce confusion, protect quality, and keep the website aligned with measurable business goals.',
    items: [
      { title: 'Discovery And Consultation', text: 'We understand your business, audience, competitors, current website, and desired outcomes.' },
      { title: 'Structure And Content Planning', text: 'We define the sitemap, page flow, conversion points, and content direction before visual development.' },
      { title: 'Design And Development', text: 'We create responsive interfaces and build the agreed functionality with speed and usability in mind.' },
      { title: 'Testing And Launch', text: 'We verify mobile layouts, forms, links, performance, and critical user journeys before deployment.' },
      { title: 'Support And Improvement', text: 'We help with updates, technical support, SEO improvements, and future functionality as the business grows.' },
    ],
  },
  security: {
    id: 'web-development-company-india-coverage',
    kicker: 'Nationwide Delivery',
    title: 'A Web Development Partner For Businesses Across India',
    text:
      'Our structured remote process helps founders, local businesses, marketing teams, manufacturers, and service companies collaborate from anywhere in India without losing clarity or project visibility.',
    items: [
      { icon: 'fa-map-marker', title: 'Service Coverage Across India', text: 'We support businesses in Gujarat, Rajasthan, Maharashtra, Delhi NCR, Karnataka, and other Indian markets through organised online communication and reviews.' },
      { icon: 'fa-comments-o', title: 'Clear Remote Collaboration', text: 'Requirements, content, feedback, approvals, and progress are managed through defined communication so every stakeholder understands the next action.' },
      { icon: 'fa-mobile', title: 'Built For Indian Mobile Users', text: 'Layouts, navigation, forms, phone call buttons, WhatsApp actions, and page speed are planned for common mobile browsing habits across India.' },
      { icon: 'fa-language', title: 'Regional And Multiple Location Scope', text: 'Where required, we can plan city pages, regional service coverage, multilingual content structure, and scalable navigation for businesses serving multiple markets.' },
    ],
    highlights: [
      {
        title: 'Technology Selected Around The Requirement',
        text: 'We recommend WordPress, Shopify, React, or custom development according to content control, integrations, scalability, timeline, and business ownership needs—not because one platform fits every project.',
      },
      {
        title: 'Business Outcomes Before Decorative Features',
        text: 'Every major page and feature should support a real purpose: explain the offer, establish trust, generate an enquiry, enable a transaction, or improve an operational workflow.',
      },
      {
        title: 'Technical Launch Essentials',
        text: 'Responsive testing, form verification, analytics readiness, basic security practices, redirects where required, and a clear SEO foundation are included in the delivery discussion.',
      },
    ],
  },
  audience: {
    image: sectionVisualImage,
    imageAlt: 'Teams reviewing website content and business planning',
    kicker: 'Who It Helps',
    title: 'Web Development That Fits Indian Businesses, Startups, And Growth Teams',
    text:
      'We design web solutions for businesses across India that need stronger online trust, clearer communication, and more enquiries from the right users.',
    items: [
      { icon: 'fa-briefcase', title: 'Service Businesses', text: 'For consultants, agencies, professionals, and companies that need better presentation and enquiries.' },
      { icon: 'fa-map-marker', title: 'Local Brands', text: 'For businesses that want stronger regional visibility, better Google presence, and clearer service discovery in their market.' },
      { icon: 'fa-bullhorn', title: 'Marketing Teams', text: 'For campaigns, landing pages, and content structures that support lead generation.' },
      { icon: 'fa-cogs', title: 'Operations Teams', text: 'For dashboards, user flows, and practical website systems connected to business work.' },
    ],
  },
  delivery: {
    kicker: 'Delivery Standard',
    title: 'How We Keep Web Projects Practical And Ready to Grow',
    text: 'Our process keeps the website clear for users, manageable for your team, and ready for continued improvement.',
    items: commonDelivery('Plan The Page Flow First', 'Build For Real User Actions', 'Keep It Easy To Improve'),
  },
  faq: {
    kicker: 'FAQ',
    title: 'Common Questions About Web Development Services',
    text: 'These answers help Indian businesses understand scope, process, technology, timelines, and what to expect from a professional web development project.',
    items: [
      { question: 'What type of websites can SwiftMaze Technology build?', answer: 'We build business websites, service websites, landing pages, portfolio websites, custom dashboards, and web applications based on your actual requirement.' },
      { question: 'Will the website be mobile responsive and built for SEO?', answer: 'Yes. We focus on responsive layouts, faster loading, clean headings, and a clear page structure so the site works well on mobile and supports SEO.' },
      { question: 'Can you redesign an existing website?', answer: 'Yes. We can redesign outdated websites to improve appearance, usability, speed, content flow, and conversion performance.' },
      { question: 'Do you help plan website structure before development?', answer: 'Yes. We first understand your business, pages, services, and user goals, then suggest the right structure before starting development.' },
      { question: 'Do you provide web development services across India?', answer: 'Yes. SwiftMaze Tech works remotely with businesses across India and manages consultation, planning, reviews, development, testing, and launch through a clear online process.' },
      { question: 'Can you build ecommerce websites and custom web applications?', answer: 'Yes. We develop ecommerce stores, customer portals, admin dashboards, integrations, and custom applications that run in the browser according to the approved project scope.' },
      { question: 'Which technologies do you use for web development projects?', answer: 'Technology depends on the project. We commonly work with WordPress, Shopify, React, Node.js, custom APIs, databases, payment gateways, CRM connections, and other practical tools suited to the requirement.' },
      { question: 'How can an Indian business work with SwiftMaze remotely?', answer: 'We manage discovery calls, requirements, content collection, design reviews, feedback, testing, and launch through a structured online workflow with clear milestones and communication.' },
      { question: 'Can you target multiple Indian cities through one website?', answer: 'Yes. When it is relevant to the actual service area, we can plan scalable location pages, internal linking, regional content, and conversion paths without duplicating thin content across cities.' },
      { question: 'Do you provide support after the website is launched?', answer: 'Yes. Depending on the agreed engagement, we can support maintenance, content updates, performance improvements, technical fixes, integrations, and ongoing website growth after launch.' },
    ],
  },
  reviews: {
    kicker: 'Reviews',
    title: 'What Clients Say About Our Web Development Work',
    text: 'Feedback from Indian and international businesses that needed practical websites built for real growth.',
    items: webGeneralReviews,
  },
  finalCta: {
    kicker: 'Start With Clarity',
    title: 'Discuss Your Website Requirement With Our India Web Development Team',
    text: 'Book a free consultation to review your idea, existing website, required pages, functionality, and the most practical development direction.',
    primaryButtonLabel: 'Book Free Consultation',
    primaryButtonSubject: 'Free Web Development Consultation India',
  },
  finalCtaPlacement: 'beforeExploreMore',
  stickyMobileCta: {
    primaryButtonLabel: 'Free Consultation',
    primaryButtonSubject: 'Free Web Development Consultation India',
  },
  inquiry: {
    defaultSubject: 'Web Development Services',
    formTitle: 'Plan Your Website',
    formSubtitle: 'Share your website idea, business goal, or current challenge and we will guide you with the right next steps.',
    trackingFormName: 'web-development inquiry form',
  },
};

export const softwareDevelopmentConfig = {
  seo: {
    title: 'Software Development Services | Custom Business Software & Web Applications',
    description:
      'SwiftMaze Tech provides software development services for custom business software, internal tools, dashboards, and scalable web applications built around real workflows.',
    canonical: 'https://www.swiftmazetech.com/services/software-development/',
    ogImage: serviceOgImageFive,
    schemaName: 'Software Development Services',
    schemaType: 'Software Development Service',
  },
  servicePath: '/services/software-development',
  hero: {
    image: softwareErpDevelopmentHero,
    kicker: 'Software Development Services',
    title: 'Custom Software Development For Scalable Business Systems',
    lead:
      'We build custom software, dashboards, and web applications for businesses that need structured systems, cleaner data flow, and scalable process support.',
    buttonLabel: 'Discuss Your Software',
    chips: ['Custom Business Software', 'Workflow Automation', 'Dashboard Systems', 'Scalable Architecture'],
  },
  capability: {
    kicker: 'What We Build',
    title: 'Software Solutions Designed Around Practical Team Usage',
    text:
      'Good software should support daily work clearly. We plan around how your team operates, what data moves where, and how the system will grow over time.',
    items: [
      { icon: 'fa-cogs', title: 'Business Software', text: 'Custom systems for operations, sales, internal approvals, reporting, and structured team workflows.' },
      { icon: 'fa-code', title: 'Web Applications', text: 'Browser-based platforms with user roles, dashboards, forms, and process visibility.' },
      { icon: 'fa-random', title: 'Workflow Automation', text: 'Automation for repetitive tasks, internal movement, status changes, and operational handoffs.' },
      { icon: 'fa-shield', title: 'Secure And Maintainable Systems', text: 'Software that stays stable, scalable, and easier to improve later.' },
    ],
  },
  cta: {
    kicker: 'Need Custom Software?',
    title: 'Let Us Plan The Right Software Direction Before Development Starts',
    text:
      'Share your business model, workflow challenge, or system requirement and we will suggest the right software architecture and delivery approach.',
    buttonLabel: 'Plan Your Software',
  },
  audience: {
    image: sectionVisualImage,
    imageAlt: 'Teams planning custom software workflows and business systems',
    kicker: 'Who It Helps',
    title: 'Software Development That Fits Growing Teams, Internal Platforms, And Process-Driven Businesses',
    text:
      'We work with operations-focused businesses that need stronger system control, cleaner reporting, and practical software built around daily usage.',
    items: [
      { icon: 'fa-building', title: 'Operational Businesses', text: 'For businesses moving from scattered manual work to structured digital processes.' },
      { icon: 'fa-users', title: 'Internal Teams', text: 'For departments that need role-based systems, task flow, and visibility into ongoing work.' },
      { icon: 'fa-bar-chart', title: 'Management Teams', text: 'For businesses that need real-time reports, dashboards, and process insight.' },
      { icon: 'fa-sitemap', title: 'Growing Companies', text: 'For organisations planning software that can expand with new modules and users.' },
    ],
  },
  delivery: {
    kicker: 'Delivery Standard',
    title: 'How We Keep Custom Software Practical, Scalable, And Easier To Maintain',
    text: 'Our work stays focused on business fit, team usability, and software that remains stable as requirements grow.',
    items: commonDelivery('Understand The Process First', 'Build Around Actual Team Usage', 'Keep Architecture Easy To Scale'),
  },
  faq: {
    kicker: 'FAQ',
    title: 'Common Questions About Software Development Services',
    text: 'These answers cover custom software planning, business fit, and what to expect during development.',
    items: [
      { question: 'What kind of software can SwiftMaze Technology build?', answer: 'We build internal business systems, dashboards, web applications, process automation tools, CRM-linked platforms, and custom software around operational needs.' },
      { question: 'Can you develop software around our existing workflow?', answer: 'Yes. We start by understanding the current workflow, user roles, pain points, and required outputs before defining the final software structure.' },
      { question: 'Will the software be scalable for future changes?', answer: 'Yes. We focus on maintainable development so new features, users, and modules can be added later without rebuilding everything.' },
      { question: 'Is custom software better than using many disconnected tools?', answer: 'In many cases, yes. Custom software can reduce duplication, improve control, and create a cleaner process than managing multiple disconnected tools.' },
    ],
  },
  reviews: {
    kicker: 'Reviews',
    title: 'What Clients Say About Our Software Development Work',
    text: 'Feedback from businesses that needed practical software delivery instead of generic systems.',
    items: softwareGeneralReviews,
  },
  inquiry: {
    defaultSubject: 'Software Development Services',
    formTitle: 'Plan Your Software',
    formSubtitle: 'Share your software requirement, workflow issue, or business goal and we will guide you with the right development direction.',
    trackingFormName: 'software-development inquiry form',
  },
};

export const mobileAppDevelopmentServicesConfig = {
  seo: {
    title: 'Mobile App Development Services | Android & iOS App Development',
    description:
      'SwiftMaze Tech provides mobile app development services for Android and iOS-ready business apps with strong UX, scalable architecture, and real-world usability.',
    canonical: 'https://www.swiftmazetech.com/services/mobile-app-development/',
    ogImage: mobileAppDevelopmentHero,
    schemaName: 'Mobile App Development Services',
    schemaType: 'Mobile App Development Service',
  },
  servicePath: '/services/mobile-app-development',
  hero: {
    image: mobileAppDevelopmentHero,
    kicker: 'Mobile App Development Services',
    title: 'Mobile App Development For Products, Services, And Business Operations',
    lead:
      'We build mobile apps with practical user flow, clean UX, and scalable backend planning for customer journeys, internal processes, and product growth.',
    buttonLabel: 'Discuss Your App',
    chips: ['Android & iOS Ready', 'Business App Planning', 'API Integration', 'User-Friendly UI'],
  },
  capability: {
    kicker: 'What We Build',
    title: 'Mobile Apps Designed For Real Users And Daily Usage',
    text:
      'A useful mobile app should be easy to use, clear in navigation, and connected to the right backend logic. We focus on practicality, not unnecessary complexity.',
    items: [
      { icon: 'fa-mobile', title: 'Customer-Facing Apps', text: 'Apps for booking, ordering, tracking, engagement, and user-facing business journeys.' },
      { icon: 'fa-briefcase', title: 'Business Utility Apps', text: 'Apps for internal teams, reporting, field operations, or workflow visibility.' },
      { icon: 'fa-cloud', title: 'API-Connected Applications', text: 'Apps connected with admin panels, CRMs, dashboards, or third-party systems.' },
      { icon: 'fa-pencil-square-o', title: 'UI And Flow Planning', text: 'Clear screens, better navigation, and user journeys planned for retention and usability.' },
    ],
  },
  cta: {
    kicker: 'Need A Mobile App?',
    title: 'Let Us Plan The Right Mobile App Direction Before Development Starts',
    text:
      'Tell us what users need to do in the app and we will suggest the right structure, platform approach, and delivery plan.',
    buttonLabel: 'Plan Your App',
  },
  audience: {
    image: sectionVisualImage,
    imageAlt: 'Teams planning mobile app experiences and backend systems',
    kicker: 'Who It Helps',
    title: 'Mobile App Development That Fits Startups, Product Teams, And Operational Businesses',
    text:
      'We build mobile apps for businesses that need smoother customer interaction, stronger internal access, or better mobile workflow execution.',
    items: [
      { icon: 'fa-rocket', title: 'Startups', text: 'For founders launching products that need clean MVP structure and future growth planning.' },
      { icon: 'fa-shopping-cart', title: 'Service And Retail Brands', text: 'For businesses that want smoother mobile journeys, repeat engagement, and easier customer action.' },
      { icon: 'fa-users', title: 'Internal Teams', text: 'For field teams, sales staff, and operations users who need mobile access to business tasks.' },
      { icon: 'fa-line-chart', title: 'Growth-Focused Businesses', text: 'For companies that need apps tied to reporting, retention, and repeat usage.' },
    ],
  },
  delivery: {
    kicker: 'Delivery Standard',
    title: 'How We Keep Mobile App Development Clear And Business-Focused',
    text: 'We keep app projects grounded in user flow, performance, and business value rather than unnecessary complexity.',
    items: commonDelivery('Map The User Flow First', 'Build Around Real App Usage', 'Keep The App Ready For Scale'),
  },
  faq: {
    kicker: 'FAQ',
    title: 'Common Questions About Mobile App Development Services',
    text: 'These answers cover planning, platform decisions, and what to expect from a professional mobile app project.',
    items: [
      { question: 'What type of mobile apps can SwiftMaze Technology develop?', answer: 'We build business apps, customer-facing apps, admin-connected apps, service apps, internal workflow apps, and platform-ready mobile products.' },
      { question: 'Do you help plan the app before development starts?', answer: 'Yes. We begin with user flow, business logic, required features, and platform direction before finalising the development approach.' },
      { question: 'Can the app connect with a website, admin panel, or CRM?', answer: 'Yes. We can build the app with backend integration so it works with dashboards, CRMs, admin systems, and APIs.' },
      { question: 'Will the app be easy for users to understand?', answer: 'That is one of our priorities. We focus on practical app navigation, clean screen structure, and a smoother user experience.' },
    ],
  },
  reviews: {
    kicker: 'Reviews',
    title: 'What Clients Say About Our Mobile App Development Work',
    text: 'Feedback from businesses that needed practical app planning, clean delivery, and user-focused execution.',
    items: appGeneralReviews,
  },
  inquiry: {
    defaultSubject: 'Mobile App Development Services',
    formTitle: 'Plan Your App',
    formSubtitle: 'Share your app idea, target users, or mobile workflow need and we will guide you with the right development path.',
    trackingFormName: 'mobile-app-development inquiry form',
  },
};

export const mobileAppDevelopmentConfig = {
  seo: {
    title: 'Mobile App Development In Modasa | Android & iOS App Development',
    description:
      'SwiftMaze Tech offers mobile app development in Modasa for Android and iOS with practical UI, scalable architecture, and business-focused app strategy.',
    canonical: 'https://www.swiftmazetech.com/services/mobile-app-development-modasa/',
    ogImage: mobileAppDevelopmentHero,
    schemaName: 'Mobile App Development In Modasa',
    schemaType: 'Mobile App Development Service',
  },
  servicePath: '/services/mobile-app-development-modasa',
  hero: {
    image: mobileAppDevelopmentHero,
    kicker: 'Mobile App Development',
    title: 'Mobile App Development In Modasa',
    lead:
      'We help businesses in Modasa and nearby areas plan mobile apps that support booking, follow-up, reporting, customer engagement, and local business workflows.',
    buttonLabel: 'Discuss Your App',
    chips: ['Android & iOS Ready', 'Modasa Business Apps', 'API Connected Apps', 'Clean Mobile UI'],
  },
  capability: {
    kicker: 'What We Build',
    title: 'Mobile Apps Planned Around Real Usage In Modasa Businesses',
    text:
      'A useful mobile app should feel fast, simple, and aligned with what your users or staff in Modasa actually need to do every day.',
    items: [
      { icon: 'fa-mobile', title: 'Customer Apps', text: 'Apps for booking, support, engagement, and repeat user interaction.' },
      { icon: 'fa-users', title: 'Internal Team Apps', text: 'Mobile solutions for staff activity, field work, reporting, and operations.' },
      { icon: 'fa-bell', title: 'Notification Workflows', text: 'Push alerts, reminders, and in-app communication for better responsiveness.' },
      { icon: 'fa-database', title: 'Backend Integration', text: 'API, dashboard, and admin panel connections for reliable business control.' },
    ],
  },
  cta: {
    kicker: 'Need A Mobile App?',
    title: 'Let Us Shape The Right App Flow For Your Modasa Business',
    text:
      'Share your app idea, user type, or business goal. We will help define the right screens, features, and rollout direction for your Modasa or nearby-area business.',
    buttonLabel: 'Plan Your App',
  },
  audience: {
    image: sectionVisualImage,
    imageAlt: 'Business teams planning app workflows and user journeys',
    kicker: 'Who It Helps',
    title: 'Apps That Fit Startups, Local Brands, And Internal Operations In Modasa',
    text:
      'We build mobile apps for Modasa businesses that need better customer convenience, cleaner internal coordination, and practical long-term mobile adoption.',
    items: [
      { icon: 'fa-shopping-cart', title: 'Service And Commerce Brands', text: 'For booking, enquiries, repeat orders, and better mobile access to services.' },
      { icon: 'fa-users', title: 'Customer Support Teams', text: 'For communication, updates, and user-facing mobile interactions.' },
      { icon: 'fa-line-chart', title: 'Growth Teams', text: 'For better user retention, onboarding, and customer journey support.' },
      { icon: 'fa-cogs', title: 'Internal Teams', text: 'For task management, field reporting, operational control, and dashboard-linked processes.' },
    ],
  },
  delivery: {
    kicker: 'Delivery Standard',
    title: 'How We Keep Mobile App Projects Practical For Modasa Business Teams',
    text: 'Our approach balances clean user experience, practical feature planning, and the kind of delivery clarity local businesses can act on confidently.',
    items: commonDelivery('Understand The Local Use Case First', 'Build For Daily Team And Customer Usage', 'Keep The App Ready For Future Expansion'),
  },
  faq: {
    kicker: 'FAQ',
    title: 'Questions Clients Ask Before Mobile App Development In Modasa',
    text: 'These are the common concerns around app planning, features, and delivery for Modasa businesses.',
    items: [
      { question: 'What kind of mobile apps can SwiftMaze Technology build?', answer: 'We build customer apps, internal team apps, booking apps, dashboard-connected apps, and business workflow apps based on your specific requirement.' },
      { question: 'Can you build apps for both Android and iOS?', answer: 'Yes. We plan app development so the final solution supports Android users and stays ready for broader mobile deployment requirements.' },
      { question: 'Do you connect the app with admin panels or APIs?', answer: 'Yes. We can integrate the app with your admin panel, backend APIs, dashboards, payment systems, and notification workflows.' },
      { question: 'Will you help define app features before development?', answer: 'Yes. We first understand the user flow, business process, and core actions so the feature plan stays clear and practical.' },
    ],
  },
  reviews: {
    kicker: 'Reviews',
    title: 'What Clients Say About Our Mobile App Development Work',
    text: 'Feedback from Indian and overseas teams that needed practical mobile app development support.',
    items: appModasaReviews,
  },
  inquiry: {
    defaultSubject: 'Mobile App Development In Modasa',
    formTitle: 'Plan Your App',
    formSubtitle: 'Share your app idea or workflow and we will help you shape the right mobile development plan.',
    trackingFormName: 'mobile-app-development-modasa inquiry form',
  },
};

export const crmConfig = {
  seo: {
    title: 'CRM Development & Marketplace Lead Automation | SwiftMaze',
    description:
      'Custom CRM development for marketplace lead automation, IndiaMART and TradeIndia enquiries, WhatsApp follow-ups, APIs, webhooks, and B2B sales workflows.',
    canonical: 'https://www.swiftmazetech.com/services/crm-development/',
    ogImage: serviceOgImageTwo,
    schemaName: 'CRM Development Services',
    schemaType: 'CRM Development Service',
  },
  servicePath: '/services/crm-development',
  hero: {
    image: whatsappCrmHero,
    kicker: 'CRM Development',
    title: 'CRM Systems For Lead And Sales Control',
    lead:
      'We build CRM systems that help teams manage leads, customer history, pipeline stages, reminders, and business follow-up in one place.',
    buttonLabel: 'Discuss Your CRM',
    chips: ['Lead Pipeline', 'Reminder Workflows', 'Customer Records', 'Sales Visibility'],
  },
  capability: {
    kicker: 'What We Build',
    title: 'CRM Features Planned Around Your Daily Sales And Customer Flow',
    text:
      'A useful CRM should match how your team actually works, so lead entry, follow-up, notes, reminders, and reporting stay simple and consistent.',
    items: [
      { icon: 'fa-users', title: 'Lead Management', text: 'Capture, organise, and track leads with source visibility and stage control.' },
      { icon: 'fa-clock-o', title: 'Follow-Up Reminders', text: 'Task scheduling and reminders so important leads do not get missed.' },
      { icon: 'fa-users', title: 'Customer Profiles', text: 'Store conversation history, notes, and business context in one place.' },
      { icon: 'fa-bar-chart', title: 'Reports And Dashboard', text: 'Visibility into team activity, conversions, pipeline movement, and sales performance.' },
    ],
  },
  cta: {
    kicker: 'Need A CRM?',
    title: 'Let Us Plan A CRM That Matches Your Sales Workflow',
    text:
      'Share how your team handles leads today and we will suggest the right CRM structure, stages, and feature set.',
    buttonLabel: 'Plan Your CRM',
  },
  audience: {
    image: sectionVisualImage,
    imageAlt: 'Teams planning sales and customer workflow systems',
    kicker: 'Who It Helps',
    title: 'CRM Solutions Built For Sales Teams, Owners, And Growing Businesses',
    text:
      'Our CRM systems help teams that need clearer lead control, stronger follow-up discipline, and better visibility into customer journeys.',
    items: [
      { icon: 'fa-briefcase', title: 'Sales Teams', text: 'For pipelines, lead stages, follow-up tasks, and better daily sales control.' },
      { icon: 'fa-building', title: 'Business Owners', text: 'For visibility into leads, conversions, team activity, and customer records.' },
      { icon: 'fa-bullhorn', title: 'Marketing Teams', text: 'For tracking lead sources and understanding which channels convert better.' },
      { icon: 'fa-users', title: 'Service Teams', text: 'For customer notes, communication history, and faster response workflows.' },
    ],
  },
  contentSections: [
    {
      id: 'crm-marketplace-leads-business-api-integrations',
      kicker: 'CRM Integrations',
      title: 'CRM Integrations For Marketplace Leads And Business APIs',
      paragraphs: [
        'SwiftMaze builds CRM integrations that bring enquiries from IndiaMART, TradeIndia, website forms, and custom lead sources into one practical sales workflow. This automated lead capture CRM can collect buyer details, product requirements, source information, and original import data so B2B teams do not have to copy every enquiry manually.',
        'Marketplace leads can be connected with WhatsApp automation for approved template follow-ups. Teams can review mapping and parser results, automation status, message delivery, lead status, template preview, and the complete delivery timeline. If a follow-up is not scheduled, the system can show a clear reason such as a missing phone number, automation trigger, template, or an ignored lead.',
        'For businesses that need deeper system connectivity, SwiftMaze CRM can support secure API keys, template message sending, API logs, signed webhooks, and sent, delivered, read, or failed events. This gives ERP, billing, ecommerce, website, and custom CRM systems a practical CRM developer API for system-to-WhatsApp workflows.',
      ],
      items: [
        { title: 'Marketplace Lead Capture', text: 'Capture IndiaMART, TradeIndia, website-form, and custom-source leads through Gmail parsing, paid API pulls, API webhooks, and payload mapping.' },
        { title: 'Structured Buyer Information', text: 'Store buyer name, phone, email, city, product, requirement, source, and raw payload as organized CRM lead data.' },
        { title: 'WhatsApp Follow-Up Automation', text: 'Connect imported leads with approved WhatsApp templates and clearly track whether automation was scheduled, delivered, read, or failed.' },
        { title: 'Developer API And Webhooks', text: 'Connect external apps, ERP, billing software, ecommerce systems, websites, and custom CRMs using API keys, logs, signing secrets, and webhook events.' },
      ],
    },
  ],
  delivery: {
    kicker: 'Delivery Standard',
    title: 'How We Keep CRM Development Practical And Easy To Adopt',
    text: 'We focus on usability, real process fit, and future scaling so your team can use the CRM daily without confusion.',
    items: commonDelivery('Map The Sales Flow First', 'Build For Team Adoption', 'Keep It Easy To Extend'),
  },
  faq: {
    kicker: 'FAQ',
    title: 'Questions Clients Ask Before CRM Development',
    text: 'These answers help clarify CRM features, process fit, and integration expectations.',
    items: [
      { question: 'Can you build a CRM based on our existing sales process?', answer: 'Yes. We first understand your current lead handling, follow-up flow, team roles, and reporting needs, then build the CRM around that process.' },
      { question: 'What can be included in a custom CRM?', answer: 'A custom CRM can include lead capture, pipeline stages, reminders, customer records, dashboards, reports, forms, roles, and integrations based on your needs.' },
      { question: 'Can the CRM connect with website forms or WhatsApp workflows?', answer: 'Yes. We can connect website forms, internal notifications, and selected communication workflows so lead entry becomes smoother.' },
      { question: 'Can SwiftMaze capture IndiaMART and TradeIndia leads?', answer: 'Yes. SwiftMaze can capture IndiaMART and TradeIndia enquiries through supported Gmail parsing, paid API pulls, API webhooks, or payload mapping, then create structured CRM leads with buyer and requirement details.' },
      { question: 'Can marketplace leads be followed up automatically on WhatsApp?', answer: 'Yes. Imported marketplace leads can be connected with approved WhatsApp templates and customer-configured automation. The system also shows why a message was not scheduled when a phone number, trigger, or template is missing.' },
      { question: 'Does SwiftMaze provide Developer API?', answer: 'Yes. SwiftMaze can provide API keys, WhatsApp template-message endpoints, API logs, webhook setup, signing secrets, and sent, delivered, read, or failed message events for custom business integrations.' },
      { question: 'Will the CRM stay easy for staff to use?', answer: 'That is one of our main focuses. We keep interfaces practical so teams can adopt the system quickly for daily work.' },
    ],
  },
  reviews: {
    kicker: 'Reviews',
    title: 'What Clients Say About Our CRM Development Work',
    text: 'Feedback from Indian and international businesses that needed practical CRM systems for daily teams.',
    items: crmReviews,
  },
  inquiry: {
    defaultSubject: 'CRM Development',
    formTitle: 'Plan Your CRM',
    formSubtitle: 'Share your lead process, follow-up workflow, or CRM requirement and we will guide you with the right plan.',
    trackingFormName: 'crm-development inquiry form',
  },
};

export const erpConfig = {
  seo: {
    title: 'ERP Development Services | Custom Business Management Software',
    description:
      'Custom ERP development services by SwiftMaze Tech to manage operations, data, inventory, billing, and reporting in one practical system.',
    canonical: 'https://www.swiftmazetech.com/services/erp-development/',
    ogImage: serviceOgImageThree,
    schemaName: 'ERP Development Services',
    schemaType: 'ERP Development Service',
  },
  servicePath: '/services/erp-development',
  hero: {
    image: softwareErpDevelopmentHero,
    kicker: 'ERP Development',
    title: 'ERP Systems For Business Operations',
    lead:
      'We build practical ERP solutions for inventory, billing, user roles, reporting, and internal management so daily work stays organised.',
    buttonLabel: 'Discuss Your ERP',
    chips: ['Inventory Flow', 'Billing Control', 'User Roles', 'Business Reporting'],
  },
  capability: {
    kicker: 'What We Build',
    title: 'ERP Modules Designed Around Real Operations, Not Extra Complexity',
    text:
      'A useful ERP should simplify daily work, bring data together, and reduce manual confusion across departments and teams.',
    items: [
      { icon: 'fa-archive', title: 'Inventory And Stock', text: 'Manage stock movement, item control, and internal visibility with cleaner workflows.' },
      { icon: 'fa-file-text-o', title: 'Billing And Invoices', text: 'Handle billing, payments, and transactional records inside one connected system.' },
      { icon: 'fa-users', title: 'Users And Roles', text: 'Control access by team, function, and level so sensitive data stays organised.' },
      { icon: 'fa-bar-chart', title: 'Reports And Analytics', text: 'Get dashboards and business reports for clearer operational decisions.' },
    ],
  },
  cta: {
    kicker: 'Need An ERP?',
    title: 'Let Us Plan The Right ERP Modules For Your Business',
    text:
      'Share your current business process, disconnected tools, or reporting challenges and we will suggest the right ERP roadmap.',
    buttonLabel: 'Plan Your ERP',
  },
  audience: {
    image: sectionVisualImage,
    imageAlt: 'Teams planning operational systems and reporting workflows',
    kicker: 'Who It Helps',
    title: 'ERP Solutions For Retail, Operations, Management, And Growing Businesses',
    text:
      'Our ERP systems are useful for businesses that need stronger process control, cleaner reporting, and better coordination between teams.',
    items: [
      { icon: 'fa-cogs', title: 'Operational Teams', text: 'For internal process control, reporting, user access, and daily execution management.' },
      { icon: 'fa-shopping-cart', title: 'Retail And Stock Teams', text: 'For inventory, billing, vendor records, and stock movement visibility.' },
      { icon: 'fa-briefcase', title: 'Business Owners', text: 'For consolidated control over departments, reports, and operational performance.' },
      { icon: 'fa-line-chart', title: 'Growth Businesses', text: 'For scalable systems that can expand with additional modules over time.' },
    ],
  },
  delivery: {
    kicker: 'Delivery Standard',
    title: 'How We Keep ERP Development Structured And Business-Focused',
    text: 'We phase the system properly so your team gets a practical implementation instead of a confusing oversized platform.',
    items: commonDelivery('Map The Modules First', 'Build For Daily Operations', 'Keep Expansion Practical'),
  },
  faq: {
    kicker: 'FAQ',
    title: 'Questions Clients Ask Before ERP Development',
    text: 'These are the common concerns around ERP planning, module design, and daily team usage.',
    items: [
      { question: 'What can be included in a custom ERP system?', answer: 'A custom ERP can include inventory, billing, purchase flow, reports, roles, user access, dashboards, and business-specific modules based on your workflow.' },
      { question: 'Is a custom ERP better than using many disconnected tools?', answer: 'For many businesses, yes. A custom ERP helps bring data, users, and operations into one structured system with less duplication and fewer manual mistakes.' },
      { question: 'Can ERP development be done in phases?', answer: 'Yes. We often recommend phased implementation so the core system starts first and additional modules can be added with lower risk.' },
      { question: 'Will the ERP be difficult for staff to learn?', answer: 'We aim to keep ERP interfaces practical and role-based so staff can understand their tasks without dealing with unnecessary complexity.' },
    ],
  },
  reviews: {
    kicker: 'Reviews',
    title: 'What Clients Say About Our ERP Development Work',
    text: 'Feedback from Indian and international businesses that needed better operational systems.',
    items: erpReviews,
  },
  inquiry: {
    defaultSubject: 'ERP Development',
    formTitle: 'Plan Your ERP',
    formSubtitle: 'Share your business workflow, reporting issue, or module requirement and we will suggest the right ERP plan.',
    trackingFormName: 'erp-development inquiry form',
  },
};

const qaReviews = [
  {
    name: 'Deep Shah',
    position: 'Startup Founder, India',
    rating: 5,
    message:
      'SwiftMaze QA testing helped us catch critical workflow bugs before release. Their reporting was clear and actionable.',
  },
  {
    name: 'Isabella Clark',
    position: 'Product QA Lead, Ireland',
    rating: 5,
    message:
      'Strong process, clean bug reports, and practical testing coverage. The team understood both product quality and release pressure.',
  },
  {
    name: 'Yash Parmar',
    position: 'Tech Manager, India',
    rating: 5,
    message:
      'We needed structured QA support and they delivered exactly that. Manual testing plus validation improved our release confidence.',
  },
  {
    name: 'Lucas Turner',
    position: 'Engineering Manager, United States',
    rating: 5,
    message:
      'Professional QA engagement overall. Their focus was not random testing, but business-critical reliability.',
  },
];

const digitalGeneralReviews = [
  {
    name: 'Krunal Shah',
    position: 'Business Owner, India',
    rating: 5,
    message:
      'SwiftMaze gave us a clearer digital marketing direction and improved lead quality instead of just sending traffic.',
  },
  {
    name: 'Mia Edwards',
    position: 'Marketing Coordinator, United Kingdom',
    rating: 5,
    message:
      'The strategy was practical, communication was clear, and the campaigns were aligned with real business goals.',
  },
  {
    name: 'Tapan Joshi',
    position: 'Service Brand Lead, India',
    rating: 5,
    message:
      'SEO, ads, and content planning were handled in a simple and structured way. We could understand what was being done.',
  },
  {
    name: 'Ava Robinson',
    position: 'Growth Manager, UAE',
    rating: 5,
    message:
      'They focused on measurable visibility and enquiries. The delivery felt organised and commercially sensible.',
  },
];

const digitalModasaReviews = [
  {
    name: 'Vishal Patel',
    position: 'Local Service Owner, Modasa',
    rating: 5,
    message:
      'SwiftMaze gave us a clearer local marketing direction. We started understanding what type of search and campaign work actually matters in our area.',
  },
  {
    name: 'Heena Shah',
    position: 'Retail Brand Coordinator, Modasa',
    rating: 5,
    message:
      'Their digital marketing suggestions were practical for a local business. The visibility work felt more structured and relevant.',
  },
  {
    name: 'Raj Mehta',
    position: 'Business Operator, Aravalli',
    rating: 5,
    message:
      'They explained SEO, ads, and content in a way that made sense for our nearby market, not just generic online marketing talk.',
  },
  {
    name: 'Priya Soni',
    position: 'Education Coordinator, Himmatnagar',
    rating: 5,
    message:
      'Good campaign guidance, clearer local intent planning, and stronger understanding of how nearby audiences search online.',
  },
];

const aiAgentReviews = [
  {
    name: 'Nikhil Verma',
    position: 'Operations Founder, India',
    rating: 5,
    message:
      'SwiftMaze focused on the workflow first and then explained where the AI agent should fit. That made the automation useful instead of gimmicky.',
  },
  {
    name: 'Lauren Price',
    position: 'Customer Experience Lead, United Kingdom',
    rating: 5,
    message:
      'Their AI approach was practical. The conversation was about support speed, handoff quality, and business value, not hype.',
  },
  {
    name: 'Naman Shah',
    position: 'Business Director, India',
    rating: 5,
    message:
      'We wanted to automate repetitive lead handling without losing clarity. The proposed AI agent flow felt realistic and well planned.',
  },
  {
    name: 'Evelyn Ross',
    position: 'Automation Consultant, Singapore',
    rating: 5,
    message:
      'Good understanding of AI-assisted workflow design. They treated the agent like part of the business system, not a standalone novelty.',
  },
];

export const qaTestingConfig = {
  seo: {
    title: 'QA Testing Services | Manual, Functional & Software QA',
    description:
      'SwiftMaze Tech provides QA testing services for functional testing, manual testing, validation, and release confidence across real-world software workflows.',
    canonical: 'https://www.swiftmazetech.com/services/qa-testing/',
    ogImage: serviceOgImageFour,
    schemaName: 'QA Testing Services',
    schemaType: 'QA Testing Service',
  },
  servicePath: '/services/qa-testing',
  hero: {
    image: softwareErpDevelopmentHero,
    kicker: 'QA Testing Services',
    title: 'QA Testing For Reliable Software Releases',
    lead:
      'We help teams validate user flows, features, and release quality through practical QA testing designed around real business risk.',
    buttonLabel: 'Discuss QA Testing',
    chips: ['Functional Testing', 'Manual Validation', 'Release Confidence', 'Issue Reporting'],
  },
  capability: {
    kicker: 'What We Cover',
    title: 'Testing Coverage Focused On Real Software Quality',
    text:
      'Good QA testing is not random checking. It should validate business logic, user flow, feature stability, and release readiness before issues reach real users.',
    items: [
      { icon: 'fa-check-circle', title: 'Functional Testing', text: 'Validate core user actions, forms, business logic, and expected feature behaviour.' },
      { icon: 'fa-hand-o-right', title: 'Manual Testing', text: 'Review real user flows and identify interface or logic issues that tools can miss.' },
      { icon: 'fa-refresh', title: 'Regression Validation', text: 'Ensure old features still work correctly after changes, updates, or fixes.' },
      { icon: 'fa-search-plus', title: 'Structured Bug Reporting', text: 'Document issues clearly with context so your team can act faster and fix accurately.' },
    ],
  },
  cta: {
    kicker: 'Need QA Support?',
    title: 'Let Us Review The Product Flow Before Your Next Release',
    text:
      'Share your software type, current issue, or release stage and we will help define the right testing coverage for your product.',
    buttonLabel: 'Plan QA Testing',
  },
  audience: {
    image: sectionVisualImage,
    imageAlt: 'Teams reviewing software quality and release workflows',
    kicker: 'Who It Helps',
    title: 'QA Testing That Fits Product Teams, Startups, And Software Owners',
    text:
      'Our QA support helps teams that want cleaner releases, fewer production issues, and stronger confidence in what users will experience.',
    items: [
      { icon: 'fa-rocket', title: 'Startups', text: 'For validating new products and reducing release risk before growth pushes more users to the platform.' },
      { icon: 'fa-code', title: 'Development Teams', text: 'For feature validation, issue tracking, regression coverage, and clearer release confidence.' },
      { icon: 'fa-users', title: 'Product Owners', text: 'For better understanding of user-facing issues, quality gaps, and business-critical bugs.' },
      { icon: 'fa-shield', title: 'Software Businesses', text: 'For reliability, consistency, and stronger quality assurance across daily software usage.' },
    ],
  },
  delivery: {
    kicker: 'Delivery Standard',
    title: 'How We Keep QA Testing Structured And Useful',
    text: 'Our process focuses on business-critical quality, clear reporting, and release-ready validation instead of random bug listing.',
    items: commonDelivery('Understand The Product First', 'Test Around Real Usage', 'Keep QA Reporting Actionable'),
  },
  faq: {
    kicker: 'FAQ',
    title: 'Questions Clients Ask Before QA Testing Starts',
    text: 'These are the common questions around testing coverage, workflow, and expected delivery.',
    items: [
      { question: 'What type of QA testing services do you provide?', answer: 'We provide practical QA support including functional testing, manual testing, regression validation, and structured issue reporting based on your software workflow.' },
      { question: 'Can SwiftMaze Technology test web applications and business software?', answer: 'Yes. We support testing for web applications, internal tools, dashboards, SaaS workflows, and other business-focused software systems.' },
      { question: 'Will you provide bug reports in a clear format?', answer: 'Yes. We focus on actionable reporting with enough context so your development team can understand, prioritise, and resolve issues faster.' },
      { question: 'Is QA testing useful even if the product is already built?', answer: 'Yes. QA testing is valuable before launch, after major updates, during release preparation, or when recurring issues are affecting user trust.' },
    ],
  },
  reviews: {
    kicker: 'Reviews',
    title: 'What Clients Say About Our QA Testing Work',
    text: 'Feedback from Indian and international teams that needed stronger testing and release confidence.',
    items: qaReviews,
  },
  inquiry: {
    defaultSubject: 'QA Testing Services',
    formTitle: 'Plan QA Testing',
    formSubtitle: 'Share your product type, release challenge, or testing need and we will suggest the right QA approach.',
    trackingFormName: 'qa-testing inquiry form',
  },
};

export const softwareDevelopmentModasaConfig = {
  seo: {
    title: 'Software Development Company in Modasa | SwiftMaze Tech',
    description:
      'SwiftMaze Tech is a software development company in Modasa building custom business software, web applications, dashboards, and scalable systems.',
    canonical: 'https://www.swiftmazetech.com/services/software-development-modasa/',
    ogImage: serviceOgImageFive,
    schemaName: 'Software Development Modasa',
    schemaType: 'Software Development Service in Modasa',
  },
  servicePath: '/services/software-development-modasa',
  hero: {
    image: softwareErpDevelopmentHero,
    kicker: 'Software Development Modasa',
    title: 'Software Development In Modasa For Business Workflows',
    lead:
      'We help businesses in Modasa and nearby areas move from scattered manual work to clearer software systems built around local operational reality.',
    buttonLabel: 'Discuss Your Software',
    chips: ['Custom Software', 'Business Workflows', 'Scalable Architecture', 'Secure Systems'],
  },
  capability: {
    kicker: 'What We Build',
    title: 'Software Solutions Planned Around Real Business Processes',
    text:
      'Custom software should match how your team actually works. Our approach focuses on process fit, usability, and long-term maintainability.',
    items: [
      { icon: 'fa-cogs', title: 'Business Software', text: 'Custom-built systems for internal operations, user roles, and structured daily workflows.' },
      { icon: 'fa-code', title: 'Web Applications', text: 'Browser-based software with dashboards, forms, data flow, and practical team access.' },
      { icon: 'fa-sitemap', title: 'ERP And CRM Linked Systems', text: 'Connected business software for reporting, customer tracking, and process control.' },
      { icon: 'fa-shield', title: 'Secure And Scalable Code', text: 'Clean architecture with room for future upgrades, better stability, and stronger control.' },
    ],
  },
  cta: {
    kicker: 'Need Software In Modasa?',
    title: 'Let Us Shape The Right Software Plan Before Development Begins',
    text:
      'Share your current process, reporting issue, or software idea and we will help define the right software direction for your Modasa business team.',
    buttonLabel: 'Plan Your Software',
  },
  audience: {
    image: sectionVisualImage,
    imageAlt: 'Teams discussing software systems and business process automation',
    kicker: 'Who It Helps',
    title: 'Software Development That Fits Local Businesses, Teams, And Growth-Stage Operations',
    text:
      'We work with businesses in Modasa and nearby cities that need local consultation, clearer internal systems, process automation, and better reporting control.',
    items: [
      { icon: 'fa-building', title: 'Growing Businesses', text: 'For companies that want to move beyond Excel and scattered tools into structured systems.' },
      { icon: 'fa-users', title: 'Operational Teams', text: 'For teams that need role-based access, better visibility, and faster daily workflows.' },
      { icon: 'fa-building', title: 'Industrial And Retail Firms', text: 'For businesses that need process control, dashboard views, and software built around operations.' },
      { icon: 'fa-line-chart', title: 'Decision Makers', text: 'For owners and managers who need better reporting, data visibility, and system control.' },
    ],
  },
  delivery: {
    kicker: 'Delivery Standard',
    title: 'How We Keep Software Development In Modasa Practical, Clear, And Scalable',
    text: 'Our work stays focused on local business understanding, real team usage, and software that remains maintainable over time.',
    items: commonDelivery('Understand The Local Workflow First', 'Build For Real Team Use', 'Keep The Software Future-Ready'),
  },
  faq: {
    kicker: 'FAQ',
    title: 'Questions Businesses Ask About Software Development In Modasa',
    text: 'These are common questions around custom software planning, process fit, and business use.',
    items: [
      { question: 'Can SwiftMaze Technology build custom software for businesses in Modasa?', answer: 'Yes. We build software systems for Modasa businesses based on their actual workflow, users, and business goals.' },
      { question: 'What type of software can you develop?', answer: 'We can build dashboards, web applications, internal business systems, reporting tools, workflow automation software, ERP modules, and CRM-linked platforms.' },
      { question: 'Will the software be scalable for future changes?', answer: 'Yes. We focus on maintainable architecture so your software can grow with new users, modules, or business requirements later.' },
      { question: 'Do you understand local business workflows before development?', answer: 'Yes. We begin by understanding the business process, pain points, team behaviour, and expected outputs before deciding the final software structure.' },
    ],
  },
  reviews: {
    kicker: 'Reviews',
    title: 'What Clients Say About Our Software Development Work',
    text: 'Feedback from Indian and international businesses that needed practical software delivery.',
    items: softwareModasaReviews,
  },
  inquiry: {
    defaultSubject: 'Software Development Modasa',
    formTitle: 'Plan Your Software',
    formSubtitle: 'Share your software requirement, business workflow, or current challenge and we will guide you with the right plan.',
    trackingFormName: 'software-development-modasa inquiry form',
  },
};

export const websiteDevelopmentModasaConfig = {
  seo: {
    title: 'Website Design and Development Company in Modasa | SwiftMaze Tech',
    description:
      'SwiftMaze Tech is a website design and development company in Modasa helping businesses build responsive, SEO-ready, and practical websites.',
    canonical: 'https://www.swiftmazetech.com/services/website-development-modasa/',
    ogImage: serviceOgImageSix,
    schemaName: 'Website Development Modasa',
    schemaType: 'Website Development Service in Modasa',
  },
  servicePath: '/services/website-development-modasa',
  hero: {
    image: webDevelopmentHero,
    kicker: 'Website Development Modasa',
    title: 'Website Development In Modasa For Business Growth',
    lead:
      'We help Modasa businesses build clear, responsive, and search-friendly websites that improve trust, visibility, and customer enquiries.',
    buttonLabel: 'Discuss Your Website',
    chips: ['Modasa-Focused SEO', 'Responsive Design', 'Business Website Flow', 'Clear Call-To-Action'],
  },
  capability: {
    kicker: 'What We Build',
    title: 'Website Solutions For Modasa Businesses That Need Better Visibility',
    text:
      'A strong local business website should be easy to understand, work smoothly on mobile, and help users contact you without confusion.',
    items: [
      { icon: 'fa-globe', title: 'Local Business Websites', text: 'Professional websites for businesses in Modasa and nearby cities that want stronger online trust.' },
      { icon: 'fa-mobile', title: 'Mobile Responsive Design', text: 'Layouts that work cleanly on mobile, tablet, and desktop without breaking the user flow.' },
      { icon: 'fa-code', title: 'CMS And Custom Builds', text: 'WordPress, Shopify, and custom website development based on your project scope.' },
      { icon: 'fa-line-chart', title: 'SEO Foundation', text: 'Local search structure, clean page setup, and website optimisation for Modasa-based visibility.' },
    ],
  },
  cta: {
    kicker: 'Need A Website In Modasa?',
    title: 'Let Us Plan The Right Website Structure For Your Local Business',
    text:
      'Share your business type, target audience, or location focus and we will suggest the right website plan for Modasa growth.',
    buttonLabel: 'Plan Your Website',
  },
  audience: {
    image: sectionVisualImage,
    imageAlt: 'Teams discussing website strategy for local businesses',
    kicker: 'Who It Helps',
    title: 'Website Development That Fits Modasa Businesses And Nearby Service Areas',
    text:
      'We work with local businesses that want stronger online presentation, better Google visibility, and cleaner lead generation from their service area.',
    items: [
      { icon: 'fa-shopping-cart', title: 'Shops And Retail Businesses', text: 'For local visibility, service presentation, and customer trust through a professional website.' },
      { icon: 'fa-briefcase', title: 'Service Providers', text: 'For businesses that need more calls, WhatsApp leads, and clearer service explanation online.' },
      { icon: 'fa-building', title: 'Industrial And Company Brands', text: 'For factories, firms, and business profiles that need a serious digital presence.' },
      { icon: 'fa-graduation-cap', title: 'Institutes And Organisations', text: 'For training centres, schools, and local organisations that need a structured website.' },
    ],
  },
  delivery: {
    kicker: 'Delivery Standard',
    title: 'How We Keep Website Projects In Modasa Practical And Growth-Oriented',
    text: 'Our process focuses on local business clarity, search readiness, and responsive user experience.',
    items: commonDelivery('Understand The Local Business First', 'Build For User Comfort', 'Keep The Website Easy To Grow'),
  },
  faq: {
    kicker: 'FAQ',
    title: 'Questions Businesses Ask About Website Development In Modasa',
    text: 'These are the common concerns around local website design, performance, and project planning.',
    items: [
      { question: 'Can SwiftMaze Technology build websites for businesses in Modasa?', answer: 'Yes. We work with businesses in Modasa and nearby areas to build practical websites that improve trust, visibility, and enquiries.' },
      { question: 'Will the website be mobile friendly for local users?', answer: 'Yes. Mobile responsiveness is a core part of our website development process because most local users browse from phones.' },
      { question: 'Do you build SEO-friendly websites for Modasa-based search?', answer: 'Yes. We structure pages with clean headings, local relevance, and proper website setup so the SEO foundation is stronger from the beginning.' },
      { question: 'Can you suggest the right type of website for our business?', answer: 'Yes. We first understand your business type, service area, and target users, then guide you toward the right website approach.' },
    ],
  },
  reviews: {
    kicker: 'Reviews',
    title: 'What Clients Say About Our Website Development In Modasa',
    text: 'Feedback from local and international businesses that trusted us for practical web delivery.',
    items: webModasaReviews,
  },
  inquiry: {
    defaultSubject: 'Website Development Modasa',
    formTitle: 'Plan Your Website',
    formSubtitle: 'Tell us about your business in Modasa or nearby cities and we will guide you with the right website plan.',
    trackingFormName: 'website-development-modasa inquiry form',
  },
};

export const digitalMarketingModasaConfig = {
  seo: {
    title: 'Digital Marketing Agency in Modasa | SwiftMaze Tech',
    description:
      'SwiftMaze Tech is a digital marketing agency in Modasa helping businesses grow visibility, leads, and enquiries through practical SEO, ads, and content strategy.',
    canonical: 'https://www.swiftmazetech.com/services/digital-marketing-modasa/',
    ogImage: digitalMarketingHero,
    schemaName: 'Digital Marketing Modasa',
    schemaType: 'Digital Marketing Service in Modasa',
  },
  servicePath: '/services/digital-marketing-modasa',
  hero: {
    image: digitalMarketingHero,
    kicker: 'Digital Marketing Modasa',
    title: 'Digital Marketing In Modasa For Leads And Growth',
    lead:
      'We help Modasa businesses improve online visibility, attract the right audience, and turn traffic into real business enquiries.',
    buttonLabel: 'Discuss Your Marketing',
    chips: ['Local SEO', 'Google Ads', 'Content Planning', 'Lead-Focused Strategy'],
  },
  capability: {
    kicker: 'What We Do',
    title: 'Marketing Services Designed Around Real Business Outcomes',
    text:
      'Effective digital marketing is not random posting or ad spending. It should support visibility, trust, and measurable lead generation for your business.',
    items: [
      { icon: 'fa-search', title: 'SEO For Modasa', text: 'Local search optimisation, page structure, and visibility planning for Modasa and nearby areas.' },
      { icon: 'fa-google', title: 'Google Ads', text: 'Paid campaign planning for businesses that need faster enquiries and controlled ad performance.' },
      { icon: 'fa-instagram', title: 'Social Media Support', text: 'Structured content, profile management, and digital presence support for growing brands.' },
      { icon: 'fa-file-text-o', title: 'Content And Conversion Strategy', text: 'Clear service messaging, landing page flow, and content support for stronger conversions.' },
    ],
  },
  cta: {
    kicker: 'Need Marketing In Modasa?',
    title: 'Let Us Plan The Right Digital Marketing Direction For Your Business',
    text:
      'Share your business type, current visibility problem, or lead goal and we will suggest the right marketing direction.',
    buttonLabel: 'Plan Your Marketing',
  },
  audience: {
    image: sectionVisualImage,
    imageAlt: 'Teams discussing digital campaigns and marketing growth',
    kicker: 'Who It Helps',
    title: 'Digital Marketing That Fits Local Businesses, Service Brands, And Growth Teams',
    text:
      'We work with businesses in Modasa and nearby areas that need stronger visibility, clearer messaging, and more enquiries from the right users.',
    items: [
      { icon: 'fa-briefcase', title: 'Service Businesses', text: 'For businesses that need more calls, WhatsApp leads, and Google visibility.' },
      { icon: 'fa-shopping-cart', title: 'Retail And Local Brands', text: 'For shops and brands that want stronger online awareness and customer recall.' },
      { icon: 'fa-building', title: 'Institutes And Organisations', text: 'For coaching, schools, and organisations that need structured digital visibility.' },
      { icon: 'fa-line-chart', title: 'Growth Teams', text: 'For businesses that want measurable campaigns instead of unstructured digital activity.' },
    ],
  },
  delivery: {
    kicker: 'Delivery Standard',
    title: 'How We Keep Digital Marketing In Modasa Practical And Business-Focused',
    text: 'Our process stays focused on clear strategy, measurable work, and long-term online visibility for local businesses.',
    items: commonDelivery('Understand The Market First', 'Execute For Real Leads', 'Keep Improvement Continuous'),
  },
  faq: {
    kicker: 'FAQ',
    title: 'Questions Businesses Ask About Digital Marketing In Modasa',
    text: 'These are common concerns around local SEO, paid ads, and digital growth planning.',
    items: [
      { question: 'What digital marketing services does SwiftMaze Technology provide in Modasa?', answer: 'We support local SEO, Google Ads, content planning, social media support, and broader digital visibility strategies for Modasa businesses.' },
      { question: 'Can digital marketing help local businesses in Modasa get more enquiries?', answer: 'Yes. With the right strategy, digital marketing can improve search visibility, ad reach, and lead quality for local service and product businesses.' },
      { question: 'Do you offer SEO for Modasa and nearby cities?', answer: 'Yes. We plan SEO with local intent so your business can target Modasa and nearby areas more effectively.' },
      { question: 'Will you suggest the right digital marketing service for our business?', answer: 'Yes. We first understand your goals, budget, and market position, then suggest the right combination of SEO, paid ads, or content support.' },
    ],
  },
  reviews: {
    kicker: 'Reviews',
    title: 'What Clients Say About Our Digital Marketing Work',
    text: 'Feedback from Indian and international businesses that wanted more visibility and enquiries.',
    items: digitalModasaReviews,
  },
  inquiry: {
    defaultSubject: 'Digital Marketing Modasa',
    formTitle: 'Plan Your Marketing',
    formSubtitle: 'Share your business, campaign goal, or current challenge and we will guide you with the right digital marketing plan.',
    trackingFormName: 'digital-marketing-modasa inquiry form',
  },
};

export const aiAgentDevelopmentConfig = {
  seo: {
    title: 'AI Agent Development Services | Custom AI Agents For Business Workflows',
    description:
      'SwiftMaze Tech builds AI agent development solutions for support, operations, lead handling, workflow automation, and business productivity.',
    canonical: 'https://www.swiftmazetech.com/services/ai-agent-development/',
    ogImage: serviceOgImageSeven,
    schemaName: 'AI Agent Development Services',
    schemaType: 'AI Agent Development Service',
  },
  servicePath: '/services/ai-agent-development',
  hero: {
    image: aiAgentDevelopmentHero,
    kicker: 'AI Agent Development',
    title: 'AI Agent Development For Support, Sales, And Operations',
    lead:
      'We design AI agents that help businesses automate responses, assist teams, qualify leads, handle repetitive actions, and improve process speed.',
    buttonLabel: 'Discuss Your AI Agent',
    chips: ['AI Workflow Agents', 'Lead Qualification', 'Support Automation', 'Internal Productivity'],
  },
  capability: {
    kicker: 'What We Build',
    title: 'AI Agents Designed Around Real Business Tasks',
    text:
      'An AI agent should support actual operations, not just act like a demo. We build AI agents around customer support, internal workflows, and business use cases that need speed and consistency.',
    items: [
      { icon: 'fa-comments', title: 'Support Agents', text: 'AI agents for FAQs, guided responses, support triage, and first-level customer handling.' },
      { icon: 'fa-filter', title: 'Lead Qualification Agents', text: 'Agents that capture needs, qualify prospects, and route enquiries to the right team.' },
      { icon: 'fa-cogs', title: 'Workflow Assistants', text: 'AI support for repetitive internal steps, data handling, and process coordination.' },
      { icon: 'fa-cogs', title: 'Integrated AI Systems', text: 'AI agents connected with CRM, WhatsApp, websites, forms, dashboards, and business tools.' },
    ],
  },
  cta: {
    kicker: 'Need An AI Agent?',
    title: 'Let Us Plan An AI Agent Around Your Actual Workflow',
    text:
      'Share your support, operations, or lead process and we will suggest where an AI agent can create real value.',
    buttonLabel: 'Plan Your AI Agent',
  },
  audience: {
    image: sectionVisualImage,
    imageAlt: 'Teams designing AI assistants for customer and business workflows',
    kicker: 'Who It Helps',
    title: 'AI Agent Development That Fits Sales, Support, And Operational Teams',
    text:
      'We build AI agents for businesses that want better response speed, process consistency, and less repetitive manual work across teams.',
    items: [
      { icon: 'fa-headphones', title: 'Support Teams', text: 'For businesses that need faster replies, triage, and cleaner support flow.' },
      { icon: 'fa-bullseye', title: 'Sales Teams', text: 'For lead capture, qualification, and routing support before human follow-up.' },
      { icon: 'fa-briefcase', title: 'Operational Businesses', text: 'For internal assistance, process automation, and productivity support.' },
      { icon: 'fa-lightbulb-o', title: 'Innovation-Focused Brands', text: 'For businesses exploring AI-led service delivery and digital transformation.' },
    ],
  },
  delivery: {
    kicker: 'Delivery Standard',
    title: 'How We Keep AI Agent Development Practical And Business-Ready',
    text: 'We focus on real use cases, proper integrations, and AI agents that support business outcomes rather than novelty.',
    items: commonDelivery('Define The Use Case First', 'Connect AI To Real Workflows', 'Keep The Agent Easy To Improve'),
  },
  faq: {
    kicker: 'FAQ',
    title: 'Common Questions About AI Agent Development',
    text: 'These answers help businesses understand where AI agents fit and how they can be deployed practically.',
    items: [
      { question: 'What is an AI agent for business use?', answer: 'An AI agent is a workflow-aware assistant that can respond, guide, qualify, automate, or support tasks based on your business process.' },
      { question: 'Can AI agents connect with our website, CRM, or WhatsApp?', answer: 'Yes. We can design AI agent workflows that connect with websites, forms, CRMs, dashboards, and communication platforms.' },
      { question: 'Is AI agent development useful only for big companies?', answer: 'No. Small and mid-sized businesses can also benefit where repetitive response handling, lead qualification, or internal task assistance is needed.' },
      { question: 'Do you customise the AI agent for our workflow?', answer: 'Yes. We plan the agent around your actual business process, user interaction, and operational objective.' },
    ],
  },
  reviews: {
    kicker: 'Reviews',
    title: 'What Clients Value In Our AI And Automation Approach',
    text: 'Feedback from teams that wanted practical automation and cleaner workflow execution.',
    items: aiAgentReviews,
  },
  inquiry: {
    defaultSubject: 'AI Agent Development',
    formTitle: 'Plan Your AI Agent',
    formSubtitle: 'Tell us what workflow you want to automate or assist and we will guide you with the right AI agent approach.',
    trackingFormName: 'ai-agent-development inquiry form',
  },
};

export const digitalMarketingServicesConfig = {
  seo: {
    title: 'Digital Marketing Services | SEO, Ads, Social Media & Content Strategy',
    description:
      'SwiftMaze Tech provides digital marketing services including SEO, Google Ads, social media marketing, content writing, and practical lead-focused strategy.',
    canonical: 'https://www.swiftmazetech.com/services/digital-marketing-services/',
    ogImage: digitalMarketingHero,
    schemaName: 'Digital Marketing Services',
    schemaType: 'Digital Marketing Service',
  },
  servicePath: '/services/digital-marketing-services',
  hero: {
    image: digitalMarketingHero,
    kicker: 'Digital Marketing Services',
    title: 'Digital Marketing Services For Visibility, Leads, And Growth',
    lead:
      'We help businesses grow through SEO, Google Ads, content writing, and social media marketing planned around real conversion goals.',
    buttonLabel: 'Discuss Your Marketing',
    chips: ['SEO Strategy', 'Google Ads', 'Social Media Marketing', 'Content Writing'],
  },
  capability: {
    kicker: 'What We Do',
    title: 'Digital Marketing Services Built Around Real Business Outcomes',
    text:
      'Good digital marketing is about visibility, trust, and conversions. We focus on channels that support measurable business growth instead of random activity.',
    items: [
      { icon: 'fa-search', title: 'SEO Services', text: 'Search visibility planning, on-page SEO, keyword strategy, and technical SEO support.' },
      { icon: 'fa-google', title: 'Google Ads Management', text: 'Paid campaigns built for lead generation, controlled budgets, and better ROI visibility.' },
      { icon: 'fa-instagram', title: 'Social Media Marketing', text: 'Profile growth, content direction, posting strategy, and stronger social brand presence.' },
      { icon: 'fa-pencil', title: 'Content Writing Services', text: 'Service pages, SEO content, landing page writing, and conversion-focused copy.' },
    ],
  },
  cta: {
    kicker: 'Need Better Digital Growth?',
    title: 'Let Us Plan The Right Digital Marketing Mix For Your Business',
    text:
      'Share your business goal, visibility challenge, or campaign need and we will suggest the right digital strategy.',
    buttonLabel: 'Plan Your Marketing',
  },
  audience: {
    image: sectionVisualImage,
    imageAlt: 'Teams planning digital campaigns, SEO, and content strategy',
    kicker: 'Who It Helps',
    title: 'Digital Marketing Services That Fit Local Brands, Service Businesses, And Growth Teams',
    text:
      'We work with businesses that need stronger search visibility, better campaign structure, and clearer lead-focused messaging online.',
    items: [
      { icon: 'fa-briefcase', title: 'Service Businesses', text: 'For businesses that want more calls, enquiries, and better online credibility.' },
      { icon: 'fa-shopping-cart', title: 'Retail And Brand Teams', text: 'For businesses growing online awareness, campaign reach, and customer recall.' },
      { icon: 'fa-bullhorn', title: 'Marketing Teams', text: 'For brands that need better content support and channel strategy execution.' },
      { icon: 'fa-line-chart', title: 'Growth-Focused Companies', text: 'For businesses that want measurable lead generation and sustained digital growth.' },
    ],
  },
  delivery: {
    kicker: 'Delivery Standard',
    title: 'How We Keep Digital Marketing Practical And Conversion-Focused',
    text: 'Our process stays focused on strategy, execution clarity, and improvements that support business outcomes.',
    items: commonDelivery('Understand The Growth Goal First', 'Execute On The Right Channels', 'Keep Campaign Improvement Ongoing'),
  },
  faq: {
    kicker: 'FAQ',
    title: 'Common Questions About Digital Marketing Services',
    text: 'These answers cover channel selection, campaign planning, and what businesses should expect from digital marketing work.',
    items: [
      { question: 'What is included in your digital marketing services?', answer: 'Our digital marketing services can include SEO, Google Ads, social media marketing, content writing, local visibility planning, and conversion-focused support.' },
      { question: 'How do you decide which service is right for a business?', answer: 'We first understand your market, goal, budget, and current visibility, then recommend the right combination of channels and execution.' },
      { question: 'Can digital marketing help generate more enquiries?', answer: 'Yes. With the right SEO, ads, content, and landing page strategy, digital marketing can improve lead quality and enquiry volume.' },
      { question: 'Do you support both local and broader marketing strategy?', answer: 'Yes. We can plan for local visibility, city-focused campaigns, and broader business growth depending on your audience and goals.' },
    ],
  },
  reviews: {
    kicker: 'Reviews',
    title: 'What Clients Say About Our Digital Marketing Services',
    text: 'Feedback from businesses that needed better visibility, stronger strategy, and practical campaign execution.',
    items: digitalGeneralReviews,
  },
  inquiry: {
    defaultSubject: 'Digital Marketing Services',
    formTitle: 'Plan Your Marketing',
    formSubtitle: 'Share your business, campaign need, or visibility challenge and we will suggest the right digital marketing direction.',
    trackingFormName: 'digital-marketing-services inquiry form',
  },
};

export const seoServiceConfig = {
  ...digitalMarketingServicesConfig,
  seo: {
    title: 'SEO Service | Search Engine Optimization For Visibility And Leads',
    description: 'SwiftMaze Tech provides SEO service for businesses that want stronger search visibility, better rankings, and more relevant enquiries.',
    canonical: 'https://www.swiftmazetech.com/services/seo-service/',
    ogImage: digitalMarketingHero,
    schemaName: 'SEO Service',
    schemaType: 'SEO Service',
  },
  servicePath: '/services/seo-service',
  hero: {
    image: digitalMarketingHero,
    kicker: 'SEO Service',
    title: 'SEO Service For Long-Term Search Visibility',
    lead: 'We help businesses improve organic visibility through keyword strategy, page optimisation, technical SEO, and content planning.',
    buttonLabel: 'Discuss SEO',
    chips: ['On-Page SEO', 'Technical SEO', 'Keyword Strategy', 'Content SEO'],
  },
  capability: {
    kicker: 'What We Do',
    title: 'SEO Services Built Around Search Intent And Lead Quality',
    text: 'SEO should bring the right visitors, not just more traffic. We focus on visibility that supports enquiries and long-term digital growth.',
    items: [
      { icon: 'fa-search', title: 'Keyword Strategy', text: 'Targeting the right commercial and service-based keywords for business growth.' },
      { icon: 'fa-file-text-o', title: 'On-Page SEO', text: 'Optimised headings, page structure, metadata, and content layout for stronger rankings.' },
      { icon: 'fa-cogs', title: 'Technical SEO', text: 'Support for crawlability, page health, internal structure, and SEO-readiness.' },
      { icon: 'fa-pencil', title: 'SEO Content Direction', text: 'Planning content that aligns with user search behaviour and business goals.' },
    ],
  },
  reviews: digitalMarketingServicesConfig.reviews,
  inquiry: {
    defaultSubject: 'SEO Service',
    formTitle: 'Plan Your SEO',
    formSubtitle: 'Tell us what visibility problem you want to solve and we will suggest the right SEO approach.',
    trackingFormName: 'seo-service inquiry form',
  },
};

export const googleAdsConfig = {
  ...digitalMarketingServicesConfig,
  seo: {
    title: 'Google Ads Services | Paid Search Campaigns For Leads And Growth',
    description: 'SwiftMaze Tech provides Google Ads services for businesses that want better paid visibility, controlled budgets, and stronger lead generation.',
    canonical: 'https://www.swiftmazetech.com/services/google-ads/',
    ogImage: digitalMarketingHero,
    schemaName: 'Google Ads Services',
    schemaType: 'Google Ads Management Service',
  },
  servicePath: '/services/google-ads',
  hero: {
    image: digitalMarketingHero,
    kicker: 'Google Ads Services',
    title: 'Google Ads Campaigns Planned For Real Business Enquiries',
    lead: 'We manage Google Ads with practical campaign structure, keyword intent targeting, and conversion-focused landing support.',
    buttonLabel: 'Discuss Google Ads',
    chips: ['Search Ads', 'Lead Generation', 'Conversion Tracking', 'Budget Control'],
  },
  inquiry: {
    defaultSubject: 'Google Ads Services',
    formTitle: 'Plan Your Google Ads',
    formSubtitle: 'Share your campaign goal, target market, or ad challenge and we will guide you with the right paid strategy.',
    trackingFormName: 'google-ads inquiry form',
  },
};

export const socialMediaMarketingConfig = {
  ...digitalMarketingServicesConfig,
  seo: {
    title: 'Social Media Marketing Services | Content, Reach And Brand Presence',
    description: 'SwiftMaze Tech provides social media marketing services to help businesses improve brand visibility, engagement, and audience consistency.',
    canonical: 'https://www.swiftmazetech.com/services/social-media-marketing/',
    ogImage: digitalMarketingHero,
    schemaName: 'Social Media Marketing Services',
    schemaType: 'Social Media Marketing Service',
  },
  servicePath: '/services/social-media-marketing',
  hero: {
    image: digitalMarketingHero,
    kicker: 'Social Media Marketing',
    title: 'Social Media Marketing For Reach, Recall, And Consistency',
    lead: 'We support businesses with social media planning, content direction, profile management, and stronger brand communication.',
    buttonLabel: 'Discuss Social Media',
    chips: ['Content Strategy', 'Brand Visibility', 'Profile Management', 'Audience Engagement'],
  },
  inquiry: {
    defaultSubject: 'Social Media Marketing Services',
    formTitle: 'Plan Your Social Media',
    formSubtitle: 'Tell us what brand visibility or engagement challenge you are facing and we will suggest the right social direction.',
    trackingFormName: 'social-media-marketing inquiry form',
  },
};

export const contentWritingServicesConfig = {
  ...digitalMarketingServicesConfig,
  seo: {
    title: 'Content Writing Services | SEO Content, Website Copy And Landing Pages',
    description: 'SwiftMaze Tech provides content writing services for SEO pages, landing pages, service pages, and business copy that supports conversions.',
    canonical: 'https://www.swiftmazetech.com/services/content-writing-services/',
    ogImage: digitalMarketingHero,
    schemaName: 'Content Writing Services',
    schemaType: 'Content Writing Service',
  },
  servicePath: '/services/content-writing-services',
  hero: {
    image: digitalMarketingHero,
    kicker: 'Content Writing Services',
    title: 'Content Writing Services For SEO, Clarity, And Conversion',
    lead: 'We write service pages, landing pages, SEO content, and conversion-focused copy that explains your offer clearly and supports lead generation.',
    buttonLabel: 'Discuss Content Writing',
    chips: ['SEO Content', 'Landing Page Copy', 'Service Page Writing', 'Conversion Messaging'],
  },
  inquiry: {
    defaultSubject: 'Content Writing Services',
    formTitle: 'Plan Your Content',
    formSubtitle: 'Share what type of content you need and we will suggest the right writing direction for SEO and conversion.',
    trackingFormName: 'content-writing-services inquiry form',
  },
};

const whatsappCrmReviews = [
  {
    name: 'Neha Sharma',
    position: 'Sales Coordinator, India',
    rating: 5,
    message:
      'After moving to WhatsApp CRM, our follow-up process became clearer. Team response time improved and leads stopped getting missed.',
    proofPoints: ['Clear follow-up stages', 'Faster team response'],
  },
  {
    name: 'Adam Foster',
    position: 'Growth Manager, UAE',
    rating: 5,
    message:
      'SwiftMaze set up a practical WhatsApp CRM flow with status tracking and templates. It worked well for daily operations.',
    proofPoints: ['Template-based workflow', 'Daily team usability'],
  },
  {
    name: 'Rajveer Patel',
    position: 'Business Owner, India',
    rating: 5,
    message:
      'The WhatsApp lead pipeline is simple and easy for our staff. We can now track chats, stages, and tasks from one place.',
    proofPoints: ['Single lead dashboard', 'Task visibility'],
  },
  {
    name: 'Emma Clarke',
    position: 'Client Success Lead, United Kingdom',
    rating: 5,
    message:
      'Good implementation quality and clean workflow planning. The team focused on practical usability rather than unnecessary complexity.',
    proofPoints: ['Clean implementation', 'Usability-first setup'],
  },
];

export const whatsappCrmConfig = {
  seo: {
    title: 'WhatsApp CRM For Marketplace Leads & API Automation',
    description:
      'WhatsApp CRM for IndiaMART and TradeIndia lead automation, WhatsApp follow-ups, developer APIs, webhooks, campaigns, sales, and customer support teams.',
    canonical: 'https://www.swiftmazetech.com/products/whatsapp-crm/',
    ogImage: serviceOgImageSeven,
    schemaName: 'SwiftMaze CRM WhatsApp CRM',
    schemaType: 'WhatsApp CRM Software Product',
    schemaEntityType: 'Product',
  },
  servicePath: '/services/whatsapp-crm',
  hero: {
    image: whatsappCrmHero,
    kicker: 'SwiftMaze WhatsApp CRM',
    title: 'WhatsApp CRM Software For Sales, Support, And Automation',
    lead:
      'Manage WhatsApp leads, customer chats, campaign messages, chatbot replies, and team follow-ups from one simple WhatsApp CRM built for sales and support teams.',
    buttonLabel: 'Get Started',
    buttonSubject: 'WhatsApp CRM Getting Started',
    actionButtons: [
      {
        label: 'Watch Tutorial',
        url: 'https://youtu.be/Y7hgaeAUjhs',
        target: '_blank',
        variant: 'ghost',
        className: 'chrome-service-hero-youtube-button',
        icon: 'fa-youtube-play',
      },
      {
        label: 'Get Started',
        url: 'https://app.swiftmazetech.com/onboarding',
        icon: 'fa-rocket',
      },
      {
        label: 'See Pricing',
        scrollToId: 'service-pricing',
        variant: 'ghost',
        icon: 'fa-tags',
      },
    ],
    chips: [],
  },
  trustStrip: {
    items: [
      { value: 'Shared Inbox', label: 'Manage Team Chats' },
      { value: 'Automation', label: 'Faster Follow-Ups' },
      { value: 'Campaigns', label: 'Send Bulk Messages' },
      { value: 'Role Based', label: 'Team Access Control' },
    ],
  },
  capability: {
    kicker: 'Key Benefits',
    title: 'Why Businesses Use WhatsApp CRM For Daily Sales And Support',
    text:
      'SwiftMaze WhatsApp CRM helps teams manage leads, chats, campaigns, and follow-ups in one place, so every WhatsApp conversation becomes easier to track and faster to handle.',
    items: [
      { icon: 'fa-bolt', title: 'Manage Leads Faster', text: 'Capture and organize WhatsApp leads in one system, so your team can reply quickly and avoid missing customer enquiries.' },
      { icon: 'fa-comments-o', title: 'Handle Team Chats Better', text: 'Use a shared inbox to manage customer conversations, assign work to team members, and keep sales and support replies clear.' },
      { icon: 'fa-cogs', title: 'Automate Follow-Ups', text: 'Use WhatsApp automation to send replies, reminders, campaign messages, and chatbot responses without doing everything manually.' },
      { icon: 'fa-line-chart', title: 'Improve Sales Tracking', text: 'Track customer conversations, lead status, follow-ups, and campaign activity so your team can understand what is working.' },
    ],
  },
  featureBreakdown: {
    kicker: 'Product Modules',
    title: 'WhatsApp CRM Features Built For Daily Team Work',
    text:
      'SwiftMaze WhatsApp CRM brings inbox, contacts, campaigns, chatbot replies, templates, and WhatsApp automation into one platform, so your team can manage customer conversations with better control.',
    items: [
      { icon: 'fa-envelope', title: 'Shared Team Inbox', text: 'Manage WhatsApp chats in one shared inbox where sales and support teams can view, reply, and handle conversations without confusion.' },
      { icon: 'fa-users', title: 'Contact Management', text: 'Save customer details, organize leads, and keep important contact information ready for follow-ups and future campaigns.' },
      { icon: 'fa-bullhorn', title: 'Campaign Manager', text: 'Create and send WhatsApp campaign messages using approved templates for promotions, updates, reminders, and customer communication.' },
      { icon: 'fa-comments', title: 'Chatbot Replies', text: 'Use chatbot replies to answer common questions, collect basic details, and reduce manual response work for your team.' },
      { icon: 'fa-file-text-o', title: 'Template Messages', text: 'Manage approved WhatsApp templates for marketing, utility, and customer updates as per WhatsApp Business API rules.' },
      { icon: 'fa-tasks', title: 'Lead And Follow-Up Tracking', text: 'Track lead status, customer replies, follow-up activity, and team actions so important conversations do not get missed.' },
      { icon: 'fa-lock', title: 'Team Roles And Access', text: 'Give the right access to team members based on their work, so sales, support, and admin users can work safely.' },
      { icon: 'fa-bar-chart', title: 'Reports And Activity View', text: 'Check campaign activity, message flow, team work, and lead handling to understand what is happening inside your WhatsApp CRM.' },
      { icon: 'fa-download', title: 'Marketplace Lead Automation', text: 'Capture IndiaMART, TradeIndia, website-form, and custom-source enquiries through Gmail parsing, API pulls, webhooks, and payload mapping. Review buyer details, raw import data, lead status, automation status, template preview, and delivery timeline from one B2B lead management software.' },
      { icon: 'fa-code', title: 'Developer API & Webhooks', text: 'Connect ERP, billing software, ecommerce systems, websites, external apps, and custom CRMs using secure API keys, WhatsApp template messaging, API logs, signing secrets, and sent, delivered, read, or failed webhook events.' },
    ],
  },
  cta: {
    kicker: 'Ready To Improve WhatsApp Work?',
    title: 'Need A Better WhatsApp Workflow?',
    text:
      'Manage leads, customer chats, campaigns, chatbot replies, and follow-ups from one simple WhatsApp CRM software built for sales and support teams. No more missed leads, delayed replies, or scattered WhatsApp follow-ups.',
    buttonLabel: 'Get Started',
    buttonUrl: 'https://app.swiftmazetech.com/',
    buttonSubject: 'WhatsApp CRM Getting Started',
    secondaryButtonLabel: 'Talk to Sales',
    secondaryButtonSubject: 'WhatsApp CRM Sales Consultation',
  },
  videoDemo: {
    kicker: 'Product Demo',
    title: 'Watch The WhatsApp CRM Software In Action',
    text: 'See how SwiftMaze helps businesses organize WhatsApp conversations, manage leads, send campaigns, use chatbot replies, and improve follow-ups with WhatsApp automation.',
    buttonLabel: 'Watch Tutorial Video',
    className: 'chrome-service-video-youtube-button',
    url: 'https://youtu.be/Y7hgaeAUjhs',
  },
  audience: {
    image: sectionVisualImage,
    imageAlt: 'Business teams using WhatsApp CRM for lead and follow-up management',
    kicker: 'Use Cases',
    title: 'Where WhatsApp CRM Fits In Your Business',
    text:
      'SwiftMaze WhatsApp CRM helps teams handle customer conversations across sales, support, marketing, and follow-ups without losing important messages or lead details.',
    items: [
      { icon: 'fa-phone', title: 'Sales Enquiry Handling', text: 'For businesses that receive leads on WhatsApp and need a simple way to track replies, follow-ups, and customer interest.' },
      { icon: 'fa-headphones', title: 'Customer Support Chats', text: 'For support teams that need to reply faster, manage common questions, and keep customer conversations easy to find.' },
      { icon: 'fa-bullhorn', title: 'Campaign Follow-Ups', text: 'For teams that send offers, updates, reminders, or announcements and want to manage customer responses after each campaign.' },
      { icon: 'fa-line-chart', title: 'Lead Nurturing', text: 'For businesses that need to stay connected with prospects through timely messages, reminders, and WhatsApp automation.' },
      { icon: 'fa-users', title: 'Team Based WhatsApp Work', text: 'For companies where multiple team members handle chats and need better visibility, ownership, and response control.' },
      { icon: 'fa-refresh', title: 'Repeat Customer Communication', text: 'For businesses that need to send regular updates, service reminders, renewal messages, booking updates, or payment reminders.' },
    ],
  },
  contentSections: [
    {
      id: 'marketplace-lead-automation-and-developer-api',
      kicker: 'New Integration Modules',
      title: 'Turn Marketplace Enquiries And Business-System Events Into WhatsApp Workflows',
      paragraphs: [
        'The Marketplace Leads module gives manufacturers, traders, agencies, ecommerce businesses, and B2B sales teams one place to manage enquiries from IndiaMART, TradeIndia, website forms, and custom sources. SwiftMaze can use Gmail email parsing, paid API pulls, API webhooks, and payload mapping to create structured leads automatically.',
        'Each imported lead can include buyer name, phone, email, city, product name, requirement or message, source, and raw payload. Teams can review parser and mapping results, lead status, WhatsApp automation, message status, template preview, and delivery timeline without switching between multiple systems.',
        'The Developer API module connects SwiftMaze WhatsApp CRM with websites, ERP, billing tools, ecommerce platforms, external apps, and custom CRM software. API keys, template-message sending, API logs, webhook signing secrets, and sent, delivered, read, or failed events support reliable custom automation without making the daily user experience technical.',
      ],
      items: [
        { title: 'IndiaMART And TradeIndia Lead CRM', text: 'Bring marketplace enquiries into a consistent pipeline instead of handling scattered emails and manual lead entry.' },
        { title: 'Clear Automation Decisions', text: 'See whether WhatsApp follow-up was scheduled and understand missing-phone, missing-trigger, missing-template, or ignored-lead reasons.' },
        { title: 'Business-System Connectivity', text: 'Use the WhatsApp CRM API to send approved templates from ERP, billing, ecommerce, websites, and external applications.' },
        { title: 'Webhook Delivery Events', text: 'Receive signed sent, delivered, read, and failed events so connected systems can keep message status updated.' },
      ],
    },
    {
      id: 'why-choose-web-development-company-india',
      kicker: 'Choosing The Right Development Partner',
      title: 'What Indian Businesses Should Expect From A Professional Web Development Company',
      paragraphs: [
        'A professional website project begins with business understanding, not with a preselected design. Your development partner should identify who the website is for, what visitors need to understand, which actions matter, and how the website will support sales, marketing, credibility, or operations.',
        'For Indian businesses, the website often needs to serve mobile users, local and national markets, enquiries through WhatsApp, multiple decision makers, and future digital marketing campaigns. These requirements should influence page structure, content hierarchy, performance, and technology from the beginning.',
        'SwiftMaze Tech keeps strategy, design, development, testing, and launch connected so the final website feels consistent and remains practical for the team that will manage it after delivery.',
      ],
      items: [
        { title: 'Business Discovery', text: 'Goals, audience, offers, competitors, service areas, and conversion priorities are clarified before layouts are finalised.' },
        { title: 'Clear Scope And Milestones', text: 'Pages, features, responsibilities, feedback rounds, and delivery stages are documented to reduce confusion.' },
        { title: 'Conversion Planning', text: 'Navigation, proof, forms, calls, WhatsApp actions, and enquiry paths are planned around real visitor decisions.' },
        { title: 'Ownership And Growth Readiness', text: 'The solution is planned so content, integrations, SEO, and functionality can evolve with the business.' },
      ],
    },
    {
      id: 'web-development-technologies-india',
      kicker: 'Technology And Platform Selection',
      title: 'Choosing Between WordPress, Shopify, React, And Custom Web Development',
      paragraphs: [
        'The best platform depends on what the website must do, who will manage it, how frequently content changes, which systems it must connect with, and how much custom behaviour is required. Selecting technology only because it is popular can create unnecessary cost or limitations later.',
        'WordPress is often suitable for content heavy business websites, while Shopify is designed around ecommerce operations. React and custom application stacks are useful when the interface, workflow, integrations, or user roles go beyond standard website behaviour.',
        'During consultation, we compare practical factors such as content control, performance, security, integrations, scalability, development time, maintenance, and total ownership before recommending a direction.',
      ],
      items: [
        { title: 'WordPress Websites', text: 'Suitable for service websites, corporate content, blogs, landing pages, and teams that need straightforward content management.' },
        { title: 'Shopify Ecommerce', text: 'Suitable for product businesses that need catalogue management, checkout, orders, apps, and a proven commerce ecosystem.' },
        { title: 'React Frontend Development', text: 'Suitable for interactive interfaces, portals, dashboards, and fast application experiences.' },
        { title: 'Custom Web Applications', text: 'Suitable when business rules, workflows, permissions, data, and integrations require a solution designed around the operation.' },
      ],
    },
    {
      id: 'industries-served-web-development-india',
      kicker: 'Industries We Support',
      title: 'Web Development Experience Across Indian Business Categories',
      paragraphs: [
        'Different industries need different trust signals and user journeys. A manufacturer may need technical product information and distributor enquiries, while a clinic needs service clarity and appointment actions. An ecommerce brand needs product discovery and checkout confidence, and a professional firm needs expertise, proof, and qualified leads.',
        'We adapt website architecture, content emphasis, integrations, and calls to action to the way customers make decisions in each category. This keeps the experience relevant instead of forcing every business into the same generic template.',
      ],
      items: [
        { title: 'Manufacturing And B2B', text: 'Company profiles, capabilities, product catalogues, certifications, industries served, and buyer enquiry workflows.' },
        { title: 'Professional Services', text: 'Pages that present expertise clearly for consultants, agencies, accountants, legal teams, technology firms, and service providers.' },
        { title: 'Healthcare And Wellness', text: 'Trustworthy service information, specialist profiles, locations, appointment enquiries, and mobile accessibility.' },
        { title: 'Education And Training', text: 'Courses, admissions, facilities, outcomes, events, student information, and enquiry management.' },
        { title: 'Retail And Ecommerce', text: 'Product discovery, catalogue structure, payment journeys, order communication, and returning customer experiences.' },
        { title: 'Community And Organisations', text: 'Member information, programmes, events, resources, updates, forms, and accessible public communication.' },
      ],
    },
    {
      id: 'website-cost-timeline-india',
      kicker: 'Planning Budget And Delivery',
      title: 'What Affects Website Development Cost And Timeline In India?',
      paragraphs: [
        'Website cost cannot be estimated responsibly from the number of pages alone. Design originality, content readiness, ecommerce requirements, user roles, integrations, data migration, animation, multilingual needs, testing, and support after launch all influence the effort required.',
        'A focused landing page and a corporate website with multiple locations have very different planning needs. Likewise, a standard ecommerce setup differs from a custom portal connected to CRM, payments, automation, or internal databases.',
        'Our free consultation is used to understand these variables before suggesting scope. This helps separate essential launch requirements from features that can be introduced in later phases.',
      ],
      items: [
        { title: 'Number And Complexity Of Pages', text: 'Unique layouts, detailed service content, location pages, catalogues, and conversion journeys require different levels of planning.' },
        { title: 'Custom Design And Functionality', text: 'Original interfaces, calculators, dashboards, portals, user accounts, and custom workflows increase design and development effort.' },
        { title: 'Content And Media Readiness', text: 'Projects move faster when approved copy, brand assets, product data, photographs, and legal information are available on time.' },
        { title: 'Integrations And Data Migration', text: 'Payment gateways, CRM, APIs, analytics, existing databases, product imports, and redirects require technical review and testing.' },
        { title: 'Testing, Launch, And Support', text: 'Browser checks, responsive QA, forms, performance, deployment, training, maintenance, and improvement plans affect final scope.' },
      ],
    },
  ],
  useCases: {
    kicker: 'Where It Fits',
    title: 'WhatsApp CRM For Businesses That Handle Customer Chats Daily',
    text:
      'SwiftMaze WhatsApp CRM is useful for businesses that receive leads, support requests, bookings, orders, or repeat customer messages on WhatsApp and need a better way to manage them.',
    items: [
      { icon: 'fa-building-o', title: 'Real Estate', text: 'Manage property enquiries, buyer follow-ups, site visit updates, and project communication from one WhatsApp CRM.' },
      { icon: 'fa-heartbeat', title: 'Clinics And Healthcare', text: 'Handle appointment enquiries, patient follow-ups, reminders, and basic support messages in a more organized way.' },
      { icon: 'fa-graduation-cap', title: 'Education And Coaching', text: 'Manage admission enquiries, course details, student follow-ups, reminders, and parent communication through WhatsApp.' },
      { icon: 'fa-shopping-cart', title: 'Ecommerce And Retail', text: 'Reply to product enquiries, order updates, payment reminders, delivery questions, and repeat customer messages faster.' },
      { icon: 'fa-plane', title: 'Travel And Service Businesses', text: 'Manage booking enquiries, customer updates, package details, support messages, and follow-ups from one shared system.' },
      { icon: 'fa-map-marker', title: 'Local Businesses', text: 'Use WhatsApp CRM software to manage daily enquiries, customer chats, campaigns, and follow-ups without losing important messages.' },
    ],
  },
  workflow: {
    kicker: 'How It Works',
    title: 'Start Managing WhatsApp Leads In Simple Steps',
    text:
      'SwiftMaze WhatsApp CRM helps your team move from scattered WhatsApp chats to a clear workflow for leads, conversations, campaigns, and follow-ups.',
    items: [
      { title: 'Connect Your WhatsApp Setup', text: 'Start with your WhatsApp Business API setup and connect it with SwiftMaze WhatsApp CRM for team based message handling.' },
      { title: 'Add Contacts And Leads', text: 'Import or add customer contacts, save lead details, and keep important information ready for sales and support work.' },
      { title: 'Create Templates And Campaigns', text: 'Prepare approved WhatsApp templates and use them for updates, offers, reminders, and customer communication.' },
      { title: 'Manage Chats From One Inbox', text: 'Let your team reply to customer messages, track conversations, and handle enquiries from a shared WhatsApp inbox.' },
      { title: 'Use Automation For Faster Replies', text: 'Set up chatbot replies, follow-up flows, and WhatsApp automation to reduce manual work and improve response speed.' },
      { title: 'Track Activity And Improve', text: 'Review campaign activity, customer responses, lead status, and team actions to understand what needs attention.' },
    ],
  },
  security: {
    kicker: 'Integrations And Security',
    title: 'Built For WhatsApp Business API, Team Access, And Safe Communication',
    text:
      'SwiftMaze WhatsApp CRM software is designed to support business communication with proper access control, approved templates, and organized customer data.',
    items: [
      { icon: 'fa-cogs', title: 'WhatsApp Business API Ready', text: 'Use your WhatsApp CRM with WhatsApp Business API based messaging for campaigns, templates, chatbot replies, and customer communication.' },
      { icon: 'fa-file-text-o', title: 'Approved Template Messaging', text: 'Send marketing, utility, and update messages using approved WhatsApp templates to keep communication structured and compliant.' },
      { icon: 'fa-lock', title: 'Role Based Team Access', text: 'Give different access to admins, sales users, support users, and team members based on their actual work.' },
      { icon: 'fa-database', title: 'Customer Data Control', text: 'Keep contacts, lead details, conversation history, and follow-up information organized inside one WhatsApp CRM software.' },
    ],
    highlights: [
      {
        title: 'Secure Team Workflow',
        text: 'Reduce the risk of missed messages, unmanaged chats, and personal phone dependency by moving team work into a controlled system.',
      },
      {
        title: 'Flexible Business Setup',
        text: 'Use SwiftMaze for sales, support, campaigns, chatbot replies, and WhatsApp automation based on your business process.',
      },
      {
        title: 'Organized Communication',
        text: 'Keep customer chats, campaign responses, lead details, and follow-up activity easier to find and manage.',
      },
    ],
  },
  delivery: {
    kicker: 'Delivery Standard',
    title: 'A WhatsApp CRM Setup Focused On Real Business Use',
    text:
      'SwiftMaze Tech does not only provide a tool. We help businesses set up a WhatsApp CRM workflow that matches how their team handles leads, chats, campaigns, and support.',
    items: [
      { number: '01', title: 'Clear Requirement Study', text: 'We first understand how your team receives WhatsApp leads, replies to customers, sends campaigns, and manages follow-ups.' },
      { number: '02', title: 'Practical CRM Setup', text: 'Your WhatsApp CRM software is planned around real daily work, so your team can use it without unnecessary confusion.' },
      { number: '03', title: 'Campaign And Template Guidance', text: 'We help you understand how templates, campaign messages, chatbot replies, and customer follow-ups should be arranged.' },
      { number: '04', title: 'Team Workflow Planning', text: 'Sales and support users can be given proper roles, access, and responsibilities so daily WhatsApp work stays organized.' },
      { number: '05', title: 'Training And Onboarding Support', text: 'Your team gets basic guidance to use contacts, inbox, campaigns, chatbot replies, and WhatsApp automation properly.' },
      { number: '06', title: 'Continuous Improvement Mindset', text: 'After setup, your workflow can be improved based on message volume, lead quality, response time, and campaign results.' },
    ],
  },
  pricing: {
    kicker: 'Plan Overview',
    title: 'Choose A WhatsApp CRM Plan That Fits Your Team',
    text:
      'Pick a plan based on your team size, contact volume, campaign needs, chatbot usage, and WhatsApp automation workflow.',
    plans: [
      {
        name: 'Free Trial',
        badge: 'Free Trial',
        value: 'Test Flow',
        caption: 'For testing the basic WhatsApp CRM flow',
        summary: 'Best for small teams that want to test shared inbox, contacts, chatbot replies, and campaign setup before choosing a paid plan.',
        metrics: [
          { label: 'Users', value: '2' },
          { label: 'Contacts', value: 'Basic' },
          { label: 'Campaigns', value: 'Limited Testing' },
        ],
        items: [
          'Basic contact management',
          'Shared WhatsApp inbox',
          'Limited campaign testing',
          'Basic chatbot flow',
          'Setup guidance',
        ],
        buttonLabel: 'Start Free Trial',
        buttonSubject: 'WhatsApp CRM Service',
      },
      {
        name: 'Basic',
        badge: 'Basic',
        value: '₹299/month',
        caption: '₹2,499/year',
        summary: 'Best for small teams using essential WhatsApp CRM features for chats, contacts, campaigns, and everyday follow-ups.',
        metrics: [
          { label: 'Monthly', value: '₹299' },
          { label: 'Annual', value: '₹2,499' },
          { label: 'Best For', value: 'Small Teams' },
        ],
        items: [
          'Contact and lead management',
          'Shared team inbox',
          'WhatsApp campaign messages',
          'Basic WhatsApp automation',
          'Template message support',
        ],
        buttonLabel: 'Get Started',
        buttonSubject: 'WhatsApp CRM Service',
        featured: true,
      },
      {
        name: 'Premium',
        badge: 'Premium',
        value: '₹499/month',
        caption: '₹4,999/year',
        summary: 'Best for growing teams using marketplace lead capture and WhatsApp follow-up automation for regular B2B enquiries.',
        metrics: [
          { label: 'Marketplace Leads', value: '1,000/month' },
          { label: 'API Pulls', value: '150/day' },
          { label: 'Annual', value: '₹4,999' },
        ],
        items: [
          'Advanced contact management',
          'Campaign scheduling',
          'Chatbot flows',
          'Lead follow-up tracking',
          'Team roles and reports',
          'Marketplace lead automation',
          'IndiaMART and TradeIndia lead capture',
          'Up to 1,000 marketplace leads per month',
          'Up to 150 marketplace API pulls per day',
        ],
        buttonLabel: 'Choose Premium',
        buttonSubject: 'WhatsApp CRM Service',
      },
      {
        name: 'Enterprise',
        badge: 'Enterprise',
        value: '₹599/month',
        caption: '₹6,999/year',
        summary: 'Best for high-volume marketplace automation, custom API workflows, and advanced integrations across business systems.',
        metrics: [
          { label: 'Marketplace Leads', value: '10,000/month' },
          { label: 'API Requests', value: '10,000/day' },
          { label: 'API Keys', value: '10' },
        ],
        items: [
          'Custom user capacity',
          'Custom contact volume',
          'Advanced WhatsApp automation',
          'Multi-team access control',
          'Custom workflow setup',
          'Up to 10,000 marketplace leads per month',
          'Up to 1,000 marketplace API pulls per day',
          'Up to 10 Developer API keys',
          'Up to 10,000 Developer API requests per day',
          'WhatsApp CRM API message logs',
          'Signed sent, delivered, read, and failed webhooks',
          'Priority support',
        ],
        buttonLabel: 'Talk To Sales',
        buttonSubject: 'WhatsApp CRM Service',
      },
    ],
  },
  faq: {
    kicker: 'FAQ',
    title: 'Questions Businesses Ask About WhatsApp CRM',
    text:
      'Simple answers about WhatsApp CRM software, WhatsApp automation, team inbox, campaigns, chatbot replies, and setup.',
    items: [
      { question: 'What is WhatsApp CRM?', answer: 'WhatsApp CRM helps businesses manage WhatsApp leads, customer chats, follow-ups, campaigns, and team replies from one organized system.' },
      { question: 'Who should use WhatsApp CRM software?', answer: 'It is useful for sales teams, support teams, real estate businesses, clinics, education teams, ecommerce stores, agencies, and local businesses that handle customer chats on WhatsApp.' },
      { question: 'Can SwiftMaze WhatsApp CRM manage leads?', answer: 'Yes. You can save contacts, manage lead details, track customer conversations, and follow up with prospects from one place.' },
      { question: 'Can SwiftMaze capture IndiaMART and TradeIndia leads?', answer: 'Yes. SwiftMaze supports marketplace lead automation for IndiaMART and TradeIndia using supported Gmail email parsing, paid API pulls, API webhooks, and payload mapping. Buyer and requirement details are converted into organized CRM leads.' },
      { question: 'Can marketplace leads be followed up automatically on WhatsApp?', answer: 'Yes. Marketplace leads can be connected with approved WhatsApp templates and customer-configured automation. The CRM shows message status and explains when automation is not scheduled because of a missing phone number, trigger, template, or ignored lead.' },
      { question: 'Does SwiftMaze provide Developer API?', answer: 'Yes. The SwiftMaze CRM Developer API supports API keys, approved WhatsApp template-message sending, API message logs, webhook setup, a signing secret, and sent, delivered, read, or failed webhook events.' },
      { question: 'Which plan includes Marketplace Leads and Developer API?', answer: 'Premium includes up to 1,000 marketplace leads per month and 150 marketplace API pulls per day. Enterprise includes up to 10,000 marketplace leads per month, 1,000 marketplace API pulls per day, 10 Developer API keys, and 10,000 Developer API requests per day. Basic is designed for core WhatsApp CRM use.' },
      { question: 'Does it support WhatsApp automation?', answer: 'Yes. SwiftMaze supports WhatsApp automation for chatbot replies, follow-ups, campaign messages, reminders, and common customer responses.' },
      { question: 'Can we send WhatsApp campaigns?', answer: 'Yes. You can send campaign messages using approved WhatsApp templates for offers, updates, reminders, and customer communication.' },
      { question: 'Does the system support chatbot replies?', answer: 'Yes. You can use chatbot replies to answer common questions, collect basic details, and reduce manual response work.' },
      { question: 'Can multiple team members use the same WhatsApp CRM?', answer: 'Yes. Your team can work with shared access, roles, and organized customer conversations instead of depending on one personal WhatsApp number.' },
      { question: 'Do you provide setup and onboarding support?', answer: 'Yes. SwiftMaze Tech can help with setup, basic training, templates, campaigns, chatbot flow, and team workflow planning.' },
    ],
  },
  reviews: {
    kicker: 'Reviews',
    title: 'What Clients Say About Our WhatsApp CRM Rollout',
    text: 'Feedback from Indian and international teams that needed practical chat-to-conversion workflow control.',
    items: whatsappCrmReviews,
  },
  finalCta: {
    kicker: 'Ready To Start?',
    title: 'Start Managing WhatsApp Leads With A Better CRM Workflow',
    text:
      'Move your WhatsApp chats, leads, campaigns, chatbot replies, and follow-ups into one simple WhatsApp CRM software built for sales and support teams.',
    primaryButtonLabel: 'Schedule Demo',
    primaryButtonSubject: 'WhatsApp CRM Demo Scheduling',
    secondaryButtonLabel: 'Start Free Trial',
    secondaryButtonSubject: 'WhatsApp CRM Free Trial',
  },
  finalCtaPlacement: 'beforeExploreMore',
  stickyMobileCta: {
    primaryButtonLabel: 'Book Demo',
    primaryButtonSubject: 'WhatsApp CRM Demo Booking',
  },
  inquiry: {
    defaultSubject: 'WhatsApp CRM Service',
    formTitle: 'Start Your WhatsApp CRM',
    formSubtitle: 'Share your current team setup, lead flow, or business requirement and we will help you plan the right WhatsApp CRM rollout.',
    trackingFormName: 'whatsapp-crm landing page inquiry form',
  },
};

export const whatsappCrmAravalliConfig = {
  ...whatsappCrmConfig,
  seo: {
    ...whatsappCrmConfig.seo,
    title: 'WhatsApp CRM in Aravalli | Sales & Lead Automation',
    description:
      'WhatsApp CRM in Aravalli for organised leads, team inbox, follow-ups, campaigns and customer support. Get a free consultation from SwiftMaze Tech.',
    canonical: 'https://www.swiftmazetech.com/services/whatsapp-crm-aravalli/',
    schemaName: 'WhatsApp CRM in Aravalli',
    schemaType: 'WhatsApp CRM Service in Aravalli',
  },
  servicePath: '/services/whatsapp-crm-aravalli',
  hero: {
    ...whatsappCrmConfig.hero,
    kicker: 'WhatsApp CRM Aravalli',
    title: 'WhatsApp CRM In Aravalli For Faster Lead Management',
    lead:
      'Help your sales and support team manage WhatsApp enquiries, customer chats, campaigns, and lead activity from one organised CRM workflow built for Aravalli businesses.',
    buttonLabel: 'Get Free Consultation',
    buttonSubject: 'Free WhatsApp CRM Consultation Aravalli',
    chips: ['Shared Team Inbox', 'Lead Tracking', 'Campaign Management', 'Local Setup Support'],
  },
  capability: {
    ...whatsappCrmConfig.capability,
    title: 'WhatsApp CRM Features For Aravalli Sales And Support Teams',
    text:
      'Move business conversations away from scattered personal chats and into a clear system where your team can respond, assign, track, and follow up properly.',
  },
  featureBreakdown: {
    ...whatsappCrmConfig.featureBreakdown,
    id: 'whatsapp-crm-features-aravalli',
  },
  videoDemo: {
    ...whatsappCrmConfig.videoDemo,
    id: 'whatsapp-crm-demo-aravalli',
  },
  cta: {
    ...whatsappCrmConfig.cta,
    id: 'whatsapp-crm-consultation-aravalli',
    kicker: 'Free CRM Consultation',
    title: 'See How WhatsApp CRM Can Fit Your Aravalli Business',
    text:
      'Tell us how your team currently handles WhatsApp leads and customer messages. We will suggest a practical CRM workflow and rollout direction without obligation.',
    buttonLabel: 'Claim Free Consultation',
    buttonSubject: 'Free WhatsApp CRM Consultation Aravalli',
    secondaryButtonLabel: undefined,
  },
  ctaPlacement: 'afterUseCases',
  audience: {
    ...whatsappCrmConfig.audience,
    title: 'Built For Aravalli Businesses That Handle Customer Chats Every Day',
    text:
      'Suitable for businesses in Modasa and across Aravalli that receive enquiries, bookings, orders, service requests, or recurring customer messages through WhatsApp.',
    items: [
      { icon: 'fa-building-o', title: 'Real Estate And Property', text: 'Track property enquiries, site visits, buyer interest, and next actions without losing conversations.' },
      { icon: 'fa-stethoscope', title: 'Clinics And Wellness', text: 'Organise appointment enquiries, reminders, service information, and patient communication after appointments.' },
      { icon: 'fa-graduation-cap', title: 'Education And Training', text: 'Manage course enquiries, admission progress, student communication, and campaign responses.' },
      { icon: 'fa-shopping-cart', title: 'Retail And Service Businesses', text: 'Handle product questions, orders, quotations, support requests, and returning customer communication.' },
    ],
  },
  useCases: {
    ...whatsappCrmConfig.useCases,
    id: 'whatsapp-crm-usecases-aravalli',
  },
  workflow: {
    ...whatsappCrmConfig.workflow,
    id: 'whatsapp-crm-process-aravalli',
  },
  faq: {
    ...whatsappCrmConfig.faq,
    title: 'Questions About WhatsApp CRM In Aravalli',
    text: 'Clear answers for local businesses planning a shared WhatsApp inbox, lead tracking, automation, or campaign workflow.',
    items: [
      { question: 'Can SwiftMaze set up WhatsApp CRM for businesses in Aravalli?', answer: 'Yes. SwiftMaze Tech supports businesses in Modasa and across Aravalli with WhatsApp CRM planning, onboarding, workflow setup, and team guidance.' },
      { question: 'Can multiple employees manage customer chats together?', answer: 'Yes. A shared team workflow allows authorised employees to respond, assign conversations, update lead status, and coordinate next steps.' },
      { question: 'Can we manage leads and reminders?', answer: 'Yes. The CRM can organise contacts, conversation context, lead stages, notes, assignments, reminders, and activity in one place.' },
      { question: 'Do you provide a free consultation before setup?', answer: 'Yes. We first understand your current WhatsApp usage, team size, message volume, and business goals before suggesting the right setup.' },
    ],
  },
  finalCta: {
    ...whatsappCrmConfig.finalCta,
    kicker: 'Free Consultation',
    title: 'Plan A Better WhatsApp Lead Workflow For Your Aravalli Business',
    text: 'Discuss your team, enquiry flow, campaigns, and lead management challenges with SwiftMaze Tech before choosing the right CRM setup.',
    primaryButtonLabel: 'Book Free Consultation',
    primaryButtonSubject: 'Free WhatsApp CRM Consultation Aravalli',
    secondaryButtonLabel: undefined,
  },
  stickyMobileCta: {
    primaryButtonLabel: 'Free Consultation',
    primaryButtonSubject: 'Free WhatsApp CRM Consultation Aravalli',
  },
  inquiry: {
    ...whatsappCrmConfig.inquiry,
    defaultSubject: 'WhatsApp CRM Aravalli',
    formTitle: 'Get A Free CRM Consultation',
    formSubtitle: 'Share your WhatsApp lead flow, team size, or current challenge and we will suggest the right next steps.',
    trackingFormName: 'whatsapp-crm-aravalli inquiry form',
  },
};

export const websiteDevelopmentAravalliConfig = {
  ...websiteDevelopmentModasaConfig,
  seo: {
    ...websiteDevelopmentModasaConfig.seo,
    title: 'Website Development Company in Aravalli | SwiftMaze Tech',
    description:
      'Website development company in Aravalli for responsive business websites, ecommerce stores and custom web solutions with a strong SEO foundation. Get a free consultation.',
    canonical: 'https://www.swiftmazetech.com/services/website-development-company-aravalli/',
    schemaName: 'Website Development Company in Aravalli',
    schemaType: 'Website Development Service in Aravalli',
  },
  servicePath: '/services/website-development-company-aravalli',
  hero: {
    ...websiteDevelopmentModasaConfig.hero,
    kicker: 'Website Development Company Aravalli',
    title: 'Website Development In Aravalli For Stronger Business Growth',
    lead:
      'SwiftMaze Tech builds responsive, fast websites with a clear SEO foundation for businesses in Modasa and across Aravalli that want better credibility, visibility, and enquiries.',
    buttonLabel: 'Get Free Consultation',
    buttonSubject: 'Free Website Consultation Aravalli',
    chips: ['Local SEO', 'Responsive Design', 'Fast Performance', 'Built for Enquiries'],
  },
  capability: {
    ...websiteDevelopmentModasaConfig.capability,
    title: 'Professional Website Solutions For Businesses Across Aravalli',
    text:
      'We plan every website around the business, local audience, service area, and action you want visitors to take—call, WhatsApp, enquire, book, or buy.',
    items: [
      { icon: 'fa-globe', title: 'Business Websites', text: 'Professional websites for service providers, companies, manufacturers, shops, institutes, and organisations.' },
      { icon: 'fa-shopping-cart', title: 'Ecommerce Websites', text: 'Responsive stores with product presentation, enquiry or checkout flows, and payment integration.' },
      { icon: 'fa-map-marker', title: 'Local SEO Landing Pages', text: 'Service pages for specific locations that improve discovery across Modasa, Aravalli, and nearby markets.' },
      { icon: 'fa-code', title: 'Custom Website Development', text: 'Portals, dashboards, forms, integrations, and practical web features built around business requirements.' },
    ],
  },
  cta: {
    ...websiteDevelopmentModasaConfig.cta,
    id: 'website-consultation-aravalli',
    kicker: 'Free Website Consultation',
    title: 'Get A Free Website Consultation For Your Aravalli Business',
    text:
      'Share your business type, current website, target locations, and required features. We will suggest the right structure and development direction without obligation.',
    buttonLabel: 'Claim Free Consultation',
    buttonSubject: 'Free Website Consultation Aravalli',
  },
  useCases: {
    id: 'website-solutions-aravalli',
    kicker: 'Local Business Solutions',
    title: 'Website Development For Different Aravalli Business Needs',
    text: 'The website structure changes with your market, customer journey, and business goal. We build around what users actually need to understand and do.',
    items: [
      { icon: 'fa-cogs', title: 'Manufacturers And B2B Firms', text: 'Company profiles, product catalogues, enquiry forms, and credibility content for buyers and business partners.' },
      { icon: 'fa-briefcase', title: 'Professional Service Providers', text: 'Clear service pages, proof, local relevance, and conversion paths that generate calls and enquiries.' },
      { icon: 'fa-graduation-cap', title: 'Schools And Institutes', text: 'Course, admission, facility, event, and contact information organised for students and parents.' },
      { icon: 'fa-heartbeat', title: 'Healthcare And Wellness', text: 'Trustworthy websites for clinics, hospitals, specialists, salons, wellness centres, and appointment enquiries.' },
    ],
  },
  audience: {
    ...websiteDevelopmentModasaConfig.audience,
    title: 'A Local Website Partner For Modasa And The Wider Aravalli District',
    text:
      'We support local businesses that want professional presentation, easier customer communication, and stronger reach beyond personal referrals.',
  },
  faq: {
    ...websiteDevelopmentModasaConfig.faq,
    title: 'Questions About Website Development In Aravalli',
    text: 'Useful answers about website planning, local SEO, mobile performance, ecommerce, and support for Aravalli businesses.',
    items: [
      { question: 'Does SwiftMaze provide website development across Aravalli?', answer: 'Yes. We work with businesses in Modasa and across the Aravalli district through direct and online consultation, structured reviews, development, and support.' },
      { question: 'Will my website target local customers in Aravalli?', answer: 'We can plan locally relevant content, service pages, technical SEO foundations, calls to action, and contact information to support local search visibility.' },
      { question: 'Can you redesign our existing business website?', answer: 'Yes. We can improve its design, mobile usability, speed, page structure, content flow, and enquiry journey according to the agreed scope.' },
      { question: 'Do you build ecommerce and custom websites?', answer: 'Yes. We develop business websites, ecommerce stores, landing pages, portals, dashboards, and custom web functionality according to your requirements.' },
      { question: 'Is the initial website consultation free?', answer: 'Yes. You can discuss your business, current challenges, required pages, and functionality before deciding the next step.' },
    ],
  },
  finalCta: {
    kicker: 'Start With A Free Consultation',
    title: 'Plan The Right Website For Your Aravalli Business',
    text: 'Talk with SwiftMaze Tech about your website idea, redesign requirement, local SEO focus, ecommerce store, or custom functionality.',
    primaryButtonLabel: 'Book Free Consultation',
    primaryButtonSubject: 'Free Website Consultation Aravalli',
  },
  finalCtaPlacement: 'beforeExploreMore',
  stickyMobileCta: {
    primaryButtonLabel: 'Free Consultation',
    primaryButtonSubject: 'Free Website Consultation Aravalli',
  },
  inquiry: {
    ...websiteDevelopmentModasaConfig.inquiry,
    defaultSubject: 'Website Development Company Aravalli',
    formTitle: 'Get A Free Website Consultation',
    formSubtitle: 'Tell us about your Aravalli business, website goal, or current challenge and we will guide you with practical next steps.',
    trackingFormName: 'website-development-aravalli inquiry form',
  },
};

// These long-form buyer guides belong only to the India web-development page.
// They were initially declared inside the WhatsApp CRM configuration block;
// move the reference before pages consume the exported configurations.
webDevelopmentConfig.contentSections = whatsappCrmConfig.contentSections;
delete whatsappCrmConfig.contentSections;
delete whatsappCrmAravalliConfig.contentSections;

export const websiteDevelopmentOmanConfig = {
  seo: {
    title: 'Website Development Agency in Oman | SwiftMaze Tech',
    description:
      'Website development agency serving Oman with responsive business websites, ecommerce stores, Arabic-ready UX, technical SEO and custom web solutions.',
    canonical: 'https://www.swiftmazetech.com/services/website-development-agency-oman/',
    ogImage: serviceOgImageOne,
    schemaName: 'Website Development Agency in Oman',
    schemaType: 'Website Development Services in Oman',
  },
  servicePath: '/services/website-development-agency-oman',
  hero: {
    image: omanWebDevelopmentHero,
    kicker: 'Website Development Agency Serving Oman',
    title: 'Website Development Agency in Oman',
    lead:
      'SwiftMaze Tech helps businesses in Oman plan and build fast, responsive and search friendly websites designed to earn trust, generate enquiries and support long term growth.',
    buttonLabel: 'Get A Free Consultation',
    buttonSubject: 'Website Development Consultation Oman',
    chips: ['Oman Market Focus', 'Arabic Ready UX', 'Technical SEO', 'Lead Focused Design'],
  },
  trustStrip: {
    items: [
      { value: 'Responsive', label: 'Mobile First Experience' },
      { value: 'SEO Ready', label: 'Search Friendly Structure' },
      { value: 'Flexible', label: 'English And Arabic Ready' },
      { value: 'Remote', label: 'Structured Delivery For Oman' },
    ],
  },
  capability: {
    kicker: 'Website Solutions For Oman',
    title: 'Professional Website Development For Businesses Across Oman',
    text:
      'Your website should communicate clearly, perform reliably and make it easy for customers to take the next step on mobile and desktop.',
    items: [
      { icon: 'fa-building-o', title: 'Corporate Websites', text: 'Credible company websites for service providers, industrial firms, consultants and growing organisations in Oman.' },
      { icon: 'fa-shopping-cart', title: 'Ecommerce Websites', text: 'Customer friendly online stores with clear product discovery, secure integrations and mobile focused buying journeys.' },
      { icon: 'fa-language', title: 'English And Arabic Ready', text: 'Layouts and content architecture planned to support bilingual publishing and right to left experiences when required.' },
      { icon: 'fa-line-chart', title: 'SEO Focused Landing Pages', text: 'Focused pages for organic search, campaigns, locations and services with clear conversion paths.' },
    ],
  },
  featureBreakdown: {
    id: 'website-development-services-oman',
    kicker: 'Complete Web Development Services',
    title: 'From Website Strategy To Launch And Continuous Improvement',
    text:
      'We combine content planning, UX, development, technical SEO and integrations so your website supports both customer acquisition and day to day business goals.',
    items: [
      { icon: 'fa-sitemap', title: 'Website Strategy And Architecture', text: 'Search intent, services, locations and conversion goals are translated into a logical sitemap before development begins.' },
      { icon: 'fa-wordpress', title: 'WordPress Development', text: 'Flexible, manageable websites with custom layouts, structured content and a clean foundation for future growth.' },
      { icon: 'fa-shopping-cart', title: 'Shopify And Ecommerce', text: 'Storefronts planned around product discovery, trust, mobile usability, checkout journeys and practical store management.' },
      { icon: 'fa-code', title: 'React And Custom Web Apps', text: 'Modern interfaces, portals, dashboards and custom browser based workflows for requirements beyond a standard website.' },
      { icon: 'fa-refresh', title: 'Website Redesign', text: 'Improve outdated design, navigation, content hierarchy, speed and lead generation while protecting valuable existing URLs.' },
      { icon: 'fa-plug', title: 'Business Integrations', text: 'Connect forms, CRM, analytics, email, WhatsApp, payment services and operational tools through suitable integrations.' },
      { icon: 'fa-tachometer', title: 'Speed And Core Web Vitals', text: 'Optimised media, responsible code loading and stable responsive layouts help users reach important information faster.' },
      { icon: 'fa-search', title: 'Technical SEO Foundation', text: 'Metadata, semantic headings, canonical URLs, crawlable navigation, structured data and sitemap readiness are planned into the build.' },
    ],
  },
  audience: {
    image: sectionVisualImage,
    imageAlt: 'Business team planning a website project for the Oman market',
    kicker: 'Who We Help',
    title: 'Website Solutions For Oman’s Diverse Business Sectors',
    text:
      'We adapt the user journey, content depth and functionality to the sector, audience and commercial goal rather than forcing every business into one template.',
    items: [
      { icon: 'fa-building', title: 'SMEs And Professional Services', text: 'Clear service presentation, credibility content and enquiry journeys for companies that need a stronger digital presence.' },
      { icon: 'fa-cogs', title: 'Industrial And B2B Companies', text: 'Structured capabilities, sectors, product information and qualified enquiry paths for complex business buyers.' },
      { icon: 'fa-hotel', title: 'Tourism And Hospitality', text: 'Mobile friendly experiences for hotels, tours, travel services and hospitality brands serving local and international visitors.' },
      { icon: 'fa-home', title: 'Real Estate And Property', text: 'Property discovery, project presentation, location information and lead capture designed for serious buyer interest.' },
    ],
  },
  portfolio: {
    id: 'oman-client-website-projects',
    kicker: 'Our Website Work In Oman',
    title: 'Websites We Built For Established Oman Businesses',
    text:
      'These live projects demonstrate how we adapt information architecture, visual design and conversion journeys to very different Oman industries and customer needs.',
    items: [
      {
        name: 'Maarij International LLC',
        type: 'maarij',
        sector: 'GRP & FRP Manufacturing · Muscat, Oman',
        logo: '/assets/images/oman-projects/maarij-international-logo.png',
        url: 'https://maarijinternational.com/',
        description:
          'A structured industrial website presenting Maarij’s manufacturing capability, extensive GRP and FRP product range, certifications, industries, project evidence and quote enquiries.',
        highlights: ['Industrial product architecture', 'Certification and project proof', 'Search focused product pages'],
      },
      {
        name: 'Bait Al Sahil Trading LLC',
        type: 'bait',
        sector: 'B2B Food Distribution · Sultanate of Oman',
        logo: '/assets/images/oman-projects/bait-al-sahil-logo.png',
        url: 'https://baitalsahil.com/',
        description:
          'A product led B2B website for an Oman food distributor, organising frozen foods, dairy and dry products into clear categories with catalogue discovery and enquiry journeys.',
        highlights: ['Large product catalogue UX', 'B2B enquiry journey', 'Mobile friendly category discovery'],
      },
    ],
  },
  contentSections: [
    {
      id: 'seo-strategy-for-oman-businesses',
      kicker: 'Oman SEO Strategy',
      title: 'A Search Ready Website Built Around Real Customer Intent',
      paragraphs: [
        'Ranking for valuable searches in Oman requires more than repeating location keywords. The website needs useful service content, clear topical coverage, sound technical foundations and pages that answer what prospective customers actually need to know.',
        'We plan page hierarchy, internal links, metadata and conversion actions together. This gives search engines a clearer understanding of the business while helping visitors move naturally from discovery to enquiry.',
      ],
      items: [
        { title: 'Search Intent Mapping', text: 'Commercial, service and location searches are mapped to the most appropriate pages instead of competing across duplicated content.' },
        { title: 'On Page SEO', text: 'Titles, descriptions, headings, copy, image context and internal links are written for clarity and relevance.' },
        { title: 'Local Discovery', text: 'When supported by genuine service coverage, content can address Muscat, Sohar, Salalah and other relevant Oman markets naturally.' },
      ],
    },
    {
      id: 'bilingual-website-planning-oman',
      kicker: 'Bilingual Experience',
      title: 'Planning English And Arabic Website Experiences Correctly',
      paragraphs: [
        'A bilingual website is not just a translation switch. Navigation, typography, page direction, content ownership and search URLs must be planned so each audience receives a coherent experience.',
        'We can prepare a scalable language structure and right to left interface support where Arabic content is part of the approved scope. Final translations should be reviewed by a fluent business representative before publication.',
      ],
      items: [
        { title: 'Language Architecture', text: 'Separate, indexable language URLs and consistent navigation help users and search engines understand each version.' },
        { title: 'RTL Ready Interface', text: 'Components can be planned for right to left reading without compromising hierarchy, spacing or mobile usability.' },
        { title: 'Content Governance', text: 'A practical publishing workflow keeps English and Arabic service information aligned as the website changes.' },
      ],
    },
    {
      id: 'conversion-focused-web-design-oman',
      kicker: 'Conversion Planning',
      title: 'Turning Website Visits Into Qualified Business Enquiries',
      paragraphs: [
        'Traffic has limited value if visitors cannot understand the offer, verify credibility or contact the business easily. Every core page should connect the customer question with proof and a relevant next action.',
        'We plan calls, forms, WhatsApp actions and supporting trust content around the buying journey. Measurement readiness also helps your team understand which pages and campaigns are producing meaningful engagement.',
      ],
      items: [
        { title: 'Clear Calls To Action', text: 'Contact options are visible at decision points without overwhelming visitors or weakening the content experience.' },
        { title: 'Trust And Proof', text: 'Company credentials, project evidence, testimonials and clear service details reduce uncertainty before an enquiry.' },
        { title: 'Analytics Readiness', text: 'Analytics and conversion events can be prepared so future SEO and campaign decisions use real performance data.' },
      ],
    },
  ],
  useCases: {
    id: 'web-solutions-across-oman',
    kicker: 'Solutions Across Oman',
    title: 'Website Types Matched To Different Growth Goals',
    text: 'The right platform and page structure depend on what the business needs customers or internal teams to accomplish.',
    items: [
      { icon: 'fa-briefcase', title: 'Lead Generation Websites', text: 'Service pages, proof, FAQs and focused contact journeys for businesses seeking qualified enquiries.' },
      { icon: 'fa-map-marker', title: 'Multi Location Websites', text: 'Scalable location architecture for businesses with genuine operations or service coverage across Oman.' },
      { icon: 'fa-shopping-cart', title: 'Online Stores', text: 'Product led experiences with practical catalogue, checkout, payment and operational requirements.' },
      { icon: 'fa-cogs', title: 'Portals And Custom Platforms', text: 'Secure dashboards, customer areas and web workflows designed around specific organisational processes.' },
    ],
  },
  cta: {
    id: 'free-website-consultation-oman',
    kicker: 'Free Website Consultation',
    title: 'Get A Practical Website Roadmap For The Oman Market',
    text: 'Share your business, audience, current website and growth priorities. We will discuss the right pages, platform, SEO direction and delivery approach.',
    buttonLabel: 'Book Free Consultation',
    buttonSubject: 'Free Website Consultation Oman',
  },
  ctaPlacement: 'afterUseCases',
  workflow: {
    id: 'website-development-process-oman',
    kicker: 'Our Process',
    title: 'A Clear Remote Website Development Process',
    text: 'Defined stages, documented feedback and milestone based reviews keep an international project transparent from discovery to launch.',
    items: [
      { title: 'Discovery And Market Context', text: 'We understand the offer, audience, Oman market priorities, competitors and measurable website goals.' },
      { title: 'SEO And Content Architecture', text: 'We plan pages, search themes, navigation, conversion paths and content requirements before design.' },
      { title: 'UX Design And Development', text: 'Responsive layouts and approved functionality are developed around usability, speed and brand credibility.' },
      { title: 'Quality Assurance', text: 'We test key browsers, screen sizes, forms, links, content, indexing signals and critical user journeys.' },
      { title: 'Launch And Improvement', text: 'Deployment, analytics readiness and an agreed support plan help the website improve after launch.' },
    ],
  },
  security: {
    id: 'oman-website-delivery-standards',
    kicker: 'Delivery Standards',
    title: 'Built For Performance, Ownership And Sustainable Growth',
    text: 'A professional website should remain usable, maintainable and ready for the next stage of marketing—not become a short lived design project.',
    items: [
      { icon: 'fa-mobile', title: 'Mobile First UX', text: 'Navigation, forms, readable content and contact actions are tested around mobile customer behaviour.' },
      { icon: 'fa-lock', title: 'Responsible Security Setup', text: 'HTTPS, dependency awareness, form protection, backups and access practices are discussed according to the platform.' },
      { icon: 'fa-dashboard', title: 'Performance Discipline', text: 'Image handling, code delivery and layout stability are considered throughout design and development.' },
      { icon: 'fa-check-circle', title: 'Business Ownership', text: 'Technology, access, content editing and handover expectations are clarified as part of the agreed project scope.' },
    ],
    highlights: [
      { title: 'No False Local Presence', text: 'SwiftMaze Tech serves Oman remotely and does not claim an Oman office unless that business presence genuinely exists.' },
      { title: 'Platform Chosen For The Requirement', text: 'WordPress, Shopify, React or custom development is recommended according to ownership, functionality and scale.' },
      { title: 'SEO Is Built Into The Structure', text: 'Search readiness begins with architecture, content quality and technical discipline rather than last minute keyword insertion.' },
    ],
  },
  delivery: {
    kicker: 'Why SwiftMaze Tech',
    title: 'A Practical International Delivery Partnership',
    text: 'We keep scope, communication, approvals and next actions visible so distance does not create avoidable project confusion.',
    items: [
      { number: '01', title: 'Structured Collaboration', text: 'Requirements, assets, feedback and approvals follow a documented remote workflow.' },
      { number: '02', title: 'Business Focused Decisions', text: 'Pages and features are connected to customer needs, marketing goals and operational reality.' },
      { number: '03', title: 'Support Beyond Launch', text: 'Ongoing improvements, maintenance and SEO support can continue under an agreed engagement.' },
    ],
  },
  faq: {
    kicker: 'Frequently Asked Questions',
    title: 'Website Development In Oman: Common Questions',
    text: 'Clear answers for Oman businesses comparing website development agencies, platforms and delivery approaches.',
    items: [
      { question: 'Does SwiftMaze Tech provide website development services in Oman?', answer: 'Yes. SwiftMaze Tech works remotely with businesses in Oman through online consultation, structured planning, design reviews, development, testing and launch support.' },
      { question: 'Do you have a physical office in Oman?', answer: 'SwiftMaze Tech currently delivers these services remotely and does not present itself as having an Oman office. Meetings, reviews and project coordination are managed online.' },
      { question: 'Can you build an English and Arabic website?', answer: 'Yes. We can plan separate language URLs, right to left interface support and a manageable bilingual structure. Arabic translations should be supplied or approved by a fluent business representative.' },
      { question: 'Will the website be optimised for SEO in Oman?', answer: 'We build a technical and on page SEO foundation including page architecture, metadata, semantic headings, internal links, crawlability, structured data readiness and location relevant content where it reflects genuine service coverage.' },
      { question: 'Which website platform should an Oman business choose?', answer: 'WordPress is often suitable for content led business websites, Shopify for managed ecommerce, and React or custom development for specialised interfaces and workflows. We recommend the platform after understanding the requirement.' },
      { question: 'Can you redesign an existing Oman business website?', answer: 'Yes. We can audit and improve content structure, mobile UX, visual credibility, speed, technical SEO and conversion journeys while planning redirects for important URLs.' },
      { question: 'How long does website development take?', answer: 'The timeline depends on page count, content readiness, languages, integrations and approval speed. A clear schedule is provided after discovery and scope confirmation.' },
      { question: 'Can you support businesses in Muscat, Sohar and Salalah?', answer: 'Yes. We can work remotely with businesses across Oman, including Muscat, Sohar and Salalah, provided the website content accurately reflects the company’s real operating or service areas.' },
      { question: 'Do you provide support after launch?', answer: 'Yes. Maintenance, content updates, performance work, technical improvements and ongoing SEO support can be provided according to an agreed support plan.' },
    ],
  },
  reviews: {
    kicker: 'Client Feedback',
    title: 'Trusted By Businesses For Practical Digital Delivery',
    text: 'Client feedback reflects our focus on clear communication, usable solutions and dependable project execution.',
    items: webGeneralReviews,
  },
  finalCta: {
    kicker: 'Plan Your Oman Website',
    title: 'Build A Website That Supports Search Visibility And Real Growth',
    text: 'Discuss your new website, redesign, ecommerce store or custom platform with the SwiftMaze Tech team.',
    primaryButtonLabel: 'Discuss Your Project',
    primaryButtonSubject: 'Website Development Project Oman',
  },
  finalCtaPlacement: 'beforeExploreMore',
  stickyMobileCta: {
    primaryButtonLabel: 'Free Consultation',
    primaryButtonSubject: 'Website Development Consultation Oman',
  },
  inquiry: {
    defaultSubject: 'Website Development Agency Oman',
    defaultCountryCode: 'OM',
    formTitle: 'Plan Your Oman Website',
    formSubtitle: 'Tell us about your business, target customers, required languages and website goals.',
    trackingFormName: 'website-development-oman inquiry form',
  },
};
